import {
  Alert,
  Autocomplete,
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import MaterialReactTable from 'material-react-table';
import React, { useEffect, useRef, useState } from 'react';
import {
  GetCarrierImportCol,
  GetCarriers,
  GetShipments,
  ImportInvoiceAuditShipments,
  MarkAsResolvedDisputedShipment,
  SendDisputedInvoiceReport,
  UpdateIAColumnMapping
} from '../../apis/Agency';
import { useSelector } from 'react-redux';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import DownloadIcon from '@mui/icons-material/Download';
import SearchIcon from '@mui/icons-material/Search';
import CalendarToday from '@mui/icons-material/CalendarToday';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import InputAdornment from '@mui/material/InputAdornment';
import { base_logo_url } from '../../apis/constants';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import CloseIcon from '@mui/icons-material/Close';
import { green, red } from '@mui/material/colors';
import { formatDateUTCRangeFilter } from '../../apis/Utils';
import { ErrorToast, successToast } from '../../components/Toasts';
import { ToastContainer } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import NoLogo from '../../assets/carrier logos/No Logo.png';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ViewShipment from '../ViewShipment/ViewShipment';
import ViewInvoiceDetails from './ViewInvoiceDetails';
import TaskIcon from '@mui/icons-material/Task';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import ClearIcon from '@mui/icons-material/Clear';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import BlockIcon from '@mui/icons-material/Block';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function InvoiceAudit() {
  const [showPreviewTable, setShowPreviewTable] = useState(false);
  const [previewTableData, setPreviewTableData] = useState([]);
  const [previewColumnsData, setPreviewColumnsData] = useState([]);
  const [previewSearchTerm, setPreviewSearchTerm] = useState('');
  const [selected, setSelected] = useState(false);
  const [previewSortConfig, setPreviewSortConfig] = useState({
    key: null,
    direction: 'asc'
  });
  const [customMapping, setCustomMapping] = useState([]);
  const fileInputRef = useRef();
  const [carrierName, setCarrierName] = useState(null);
  const [carrierApiNames, setCarrierApiNames] = useState([]);
  const [disputedShipments, setDisputedShipments] = useState([]);

  const [selectCarrierLoading, setSelectCarrierLoading] = useState('');
  const [apiCarrierCols, setApiCarrierCols] = useState([]);
  const [fileName, setFileName] = useState('');
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileNameErr, setFileNameErr] = useState(false);
  const [columns, setColumns] = useState([]);
  const [previewColumns, setPreviewColumns] = useState([]);
  const [rowsData, setRowsData] = useState([]);
  const [fileColTypes, setFileColTypes] = useState([]);
  const [validRowsFile, setValidRowsFile] = useState([]);
  const [inValidRowsFile, setInValidRowsFile] = useState([]);
  const [comparisonData, setComparisonData] = useState([]);
  const [importedOriginalApiRes, setImportedOriginalApiRes] = useState([]);
  const [allColumnsMatched, setAllColumnsMatched] = useState(true);
  const [matchedCount, setMatchedCount] = useState('');
  const [shipmentsLoader, setShipmentsLoader] = useState(false);
  const [value, setValue] = useState(0);
  const [markAsResolDialg, setMarkAsResolDialg] = useState(false);
  const [currentRowData, setCurrentRowData] = useState('');
  const [rowSelection, setRowSelection] = useState({});
  const [open, setOpen] = React.useState(false);
  const [viewInValidRecords, setViewInValidRecords] = useState(false);
  const [viewInValidRecordsCopy, setViewInValidRecordsCopy] = useState([]);
  const [apiCarrierColsDetails, setApiCarrierColsDetails] = useState([]);
  const [iAColumnMapping, setIAColumnMapping] = useState([]);
  const [showMappingDialog, setShowMappingDialog] = useState(false);
  const [columnMappings, setColumnMappings] = useState([]); // Array of {carrierField, uploadedField, isMapped}
  const [mappedCount, setMappedCount] = useState(0);
  const [isMappingComplete, setIsMappingComplete] = useState(false);
  const [proNumberKey, setProNumberKey] = useState('PRO#'); // Default value
  const [netChargeKey, setNetChargeKey] = useState('Net Charge');
  const tstdt = new Date('2023-10-01');
  const toDateRange = new Date();
  toDateRange.setDate(tstdt.getDate() + 360);

  const [datesRange, setDatesRange] = useState({
    from: formatDateUTCRangeFilter(tstdt),
    to: formatDateUTCRangeFilter(toDateRange)
  });

  const carrierProLabels = {
    SAIA: 'PRO#',
    FedEx: 'Tracking Number',
    'R and L Carriers': 'ProNumber',
    SEFL: 'PRO',
    ESTES: 'PRO',
    XPO: 'PRO Number',
    'AAA Cooper': 'PRO#'
  };

  // Helper function to get carrier-specific PRO label
  const getCarrierProLabel = carrierName => {
    if (!carrierName) return 'PRO/Tracking #';
    return carrierProLabels[carrierName] || 'PRO/Tracking #';
  };

  const previewCols = [
    // SAIA
    { accessorKey: 'PRO#', header: 'PRO#', carrier: 'SAIA', type: '' },
    { accessorKey: 'BOL#', header: 'BOL#', carrier: 'SAIA', type: '' },
    { accessorKey: 'NETCHG', header: 'NETCHG', carrier: 'SAIA', type: '' },
    {
      accessorKey: 'DISCOUNT$',
      header: 'DISCOUNT$',
      carrier: 'SAIA',
      type: ''
    },
    { accessorKey: 'CHARGES$', header: 'CHARGES$', carrier: 'SAIA', type: '' },
    {
      accessorKey: 'FUELSURCHARGE',
      header: 'FUELSURCHARGE',
      carrier: 'SAIA',
      type: ''
    },

    // FedEx
    {
      accessorKey: 'Tracking Number',
      header: 'Tracking Number',
      carrier: 'FedEx',
      type: ''
    },
    {
      accessorKey: 'BOL Number',
      header: 'BOL Number',
      carrier: 'FedEx',
      type: ''
    },
    {
      accessorKey: 'Net Charge',
      header: 'Net Charge',
      carrier: 'FedEx',
      type: ''
    },
    {
      accessorKey: 'Base Discount',
      header: 'Base Discount',
      carrier: 'FedEx',
      type: ''
    },
    {
      accessorKey: 'Gross Charge',
      header: 'Gross Charge',
      carrier: 'FedEx',
      type: ''
    },
    { accessorKey: 'FSC', header: 'FSC', carrier: 'FedEx', type: '' },
    {
      accessorKey: 'Accessorials',
      header: 'Accessorials',
      carrier: 'FedEx',
      type: ''
    },

    // R and L
    {
      accessorKey: 'ProNumber',
      header: 'ProNumber',
      carrier: 'R and L Carriers',
      type: ''
    },
    {
      accessorKey: 'BOLNumber',
      header: 'BOLNumber',
      carrier: 'R and L Carriers',
      type: ''
    },
    {
      accessorKey: 'TotalCharge',
      header: 'TotalCharge',
      carrier: 'R and L Carriers',
      type: ''
    },
    {
      accessorKey: 'DISCOUNT$',
      header: 'DISCOUNT$',
      carrier: 'R and L Carriers',
      type: ''
    },
    {
      accessorKey: 'GrossCharge',
      header: 'GrossCharge',
      carrier: 'R and L Carriers',
      type: ''
    },
    {
      accessorKey: 'FSC',
      header: 'FSC',
      carrier: 'R and L Carriers',
      type: ''
    },
    {
      accessorKey: 'OtherAccessorials',
      header: 'OtherAccessorials',
      carrier: 'R and L Carriers',
      type: ''
    },

    // AAA Cooper
    { accessorKey: 'PRO#', header: 'PRO#', carrier: 'AAA Cooper', type: '' },
    { accessorKey: 'BOL#', header: 'BOL#', carrier: 'AAA Cooper', type: '' },
    { accessorKey: 'CHGS', header: 'CHGS', carrier: 'AAA Cooper', type: '' },

    // SEFL
    { accessorKey: 'PRO', header: 'PRO', carrier: 'SEFL', type: '' },
    { accessorKey: 'BL #', header: 'BL #', carrier: 'SEFL', type: '' },
    {
      accessorKey: 'NET CHARGES',
      header: 'NET CHARGES',
      carrier: 'SEFL',
      type: ''
    },
    {
      accessorKey: 'GROSS CHARGES',
      header: 'GROSS CHARGES',
      carrier: 'SEFL',
      type: ''
    },
    {
      accessorKey: 'FUEL SURCHARGE',
      header: 'FUEL SURCHARGE',
      carrier: 'SEFL',
      type: ''
    },
    {
      accessorKey: 'ACCESSORIAL CHG 01',
      header: 'ACCESSORIAL CHG 01',
      carrier: 'SEFL',
      type: ''
    },

    // XPO
    {
      accessorKey: 'PRO Number',
      header: 'PRO Number',
      carrier: 'XPO',
      type: ''
    },
    {
      accessorKey: 'BOL Number',
      header: 'BOL Number',
      carrier: 'XPO',
      type: ''
    },
    {
      accessorKey: 'Net Revenue',
      header: 'Net Revenue',
      carrier: 'XPO',
      type: ''
    },
    {
      accessorKey: 'Gross Charges',
      header: 'Gross Charges',
      carrier: 'XPO',
      type: ''
    },
    {
      accessorKey: 'Total Accsrl',
      header: 'Total Accsrl',
      carrier: 'XPO',
      type: ''
    },

    // Estes
    { accessorKey: 'PRO', header: 'PRO', carrier: 'ESTES', type: '' },
    { accessorKey: 'BOL', header: 'BOL', carrier: 'ESTES', type: '' },
    {
      accessorKey: 'NET CHARGES',
      header: 'NET CHARGES',
      carrier: 'ESTES',
      type: ''
    },
    {
      accessorKey: 'FUEL CHARGES',
      header: 'FUEL CHARGES',
      carrier: 'ESTES',
      type: ''
    },
    {
      accessorKey: 'ACCESSORIALS',
      header: 'ACCESSORIALS',
      carrier: 'ESTES',
      type: ''
    }
  ];
  // UPDATED: Fix Excel dates with 1-day correction - ONLY for date columns
  const fixExcelDates = worksheet => {
    if (!worksheet || !worksheet['!ref']) return worksheet;

    const range = XLSX.utils.decode_range(worksheet['!ref']);

    // First, get the header row to identify date columns
    const firstRowCells = [];
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cell_address = { c: C, r: range.s.r };
      const cell_ref = XLSX.utils.encode_cell(cell_address);
      if (worksheet[cell_ref]) {
        firstRowCells[C] = String(worksheet[cell_ref].v || '').toLowerCase();
      }
    }

    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
      // Skip header row
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cell_address = { c: C, r: R };
        const cell_ref = XLSX.utils.encode_cell(cell_address);

        if (worksheet[cell_ref]) {
          const cell = worksheet[cell_ref];
          const headerName = firstRowCells[C] || '';

          // Only convert if it's a date column and looks like an Excel date serial number
          const isDateColumn =
            headerName.includes('date') ||
            headerName.includes('time') ||
            headerName === 'pdate' ||
            headerName.includes('delivery') ||
            headerName.includes('pickup');

          if (
            isDateColumn &&
            cell.t === 'n' &&
            typeof cell.v === 'number' &&
            cell.v >= 1 &&
            cell.v <= 50000
          ) {
            try {
              // Excel date epoch: December 30, 1899
              const excelEpoch = new Date(Date.UTC(1899, 11, 30));

              // Adjust for Excel's 1900 leap year bug
              let excelDate = cell.v;

              // Excel incorrectly counts Feb 29, 1900 as day 60
              if (excelDate >= 60) {
                excelDate -= 1;
              }

              // Convert to JavaScript date
              const jsDate = new Date(
                excelEpoch.getTime() + (excelDate - 1) * 86400000
              );

              // Format as MM/DD/YYYY
              const month = String(jsDate.getUTCMonth() + 1).padStart(2, '0');
              const day = String(jsDate.getUTCDate()).padStart(2, '0');
              const year = jsDate.getUTCFullYear();

              // Create formatted date string
              const formattedDate = `${month}/${day}/${year}`;

              // Change cell type to string and set formatted date
              cell.t = 's';
              cell.v = formattedDate;
              cell.w = formattedDate;
            } catch (error) {
              console.warn(
                `Could not convert Excel date at ${cell_ref}:`,
                cell.v
              );
              cell.t = 's';
              cell.v = String(cell.v);
              cell.w = String(cell.v);
            }
          } else if (!isDateColumn && cell.t === 'n') {
            // For non-date numeric columns, keep them as strings but don't format as dates
            cell.t = 's';
            cell.v = String(cell.v);
            cell.w = String(cell.v);
          }
        }
      }
    }

    return worksheet;
  };
  useEffect(() => {
    if (apiCarrierColsDetails && apiCarrierColsDetails.length > 0) {
      // Find the PRO number key that is actually mapped in columnMappings
      const mappedProKey = columnMappings.find(m => {
        if (!m.isMapped || !m.carrierField) return false;
        const field = m.carrierField.toLowerCase();
        return (
          field.includes('pro') ||
          field.includes('tracking') ||
          field.includes('pronumber') ||
          field.includes('pro#')
        );
      })?.carrierField;

      if (mappedProKey) {
        setProNumberKey(mappedProKey);
      } else {
        // If not mapped yet, find the key from apiCarrierColsDetails
        const apiProKey =
          apiCarrierColsDetails.find(col => {
            const key = col.key?.toLowerCase() || '';
            return (
              key.includes('pro') ||
              key.includes('tracking') ||
              key.includes('pronumber') ||
              key.includes('pro#')
            );
          })?.key || 'PRO#';
        setProNumberKey(apiProKey);
      }

      // Find Net Charge key that is actually mapped
      const netChargePatterns = [
        'netchg',
        'netcharge',
        'net charge',
        'totalcharge',
        'net revenue',
        'chgs'
      ];

      const mappedNetKey = columnMappings.find(m => {
        if (!m.isMapped || !m.carrierField) return false;
        const field = m.carrierField.toLowerCase();
        return netChargePatterns.some(pattern => field.includes(pattern));
      })?.carrierField;

      if (mappedNetKey) {
        setNetChargeKey(mappedNetKey);
      } else {
        // If not mapped yet, find the key from apiCarrierColsDetails
        const apiNetKey =
          apiCarrierColsDetails.find(col => {
            const key = col.key?.toLowerCase() || '';
            return netChargePatterns.some(pattern => key.includes(pattern));
          })?.key || 'Net Charge';
        setNetChargeKey(apiNetKey);
      }
    }
  }, [apiCarrierColsDetails, columnMappings]);

  const handleClickOpen = () => {
    setOpen(true);
    setShipmentsLoader(false);
  };

  const handleClose = () => {
    setOpen(false);
    setViewInValidRecords(false);
    handleChange('event', 1);
  };

  // Initialize column mappings - FIXED to include savedValue
  const initializeColumnMappings = (carrierColumns, uploadedColumns) => {
    const mappings = [];
    let mappedCount = 0;

    // Track which uploaded columns have been mapped
    const mappedUploadedCols = new Set();

    // FIRST: Create a complete list of carrier fields from iAColumnMapping
    // This ensures we include ALL fields that the carrier supports
    const allCarrierFields = [];

    // Add fields from iAColumnMapping Keys with their saved values
    if (iAColumnMapping && iAColumnMapping.length > 0) {
      iAColumnMapping.forEach(item => {
        allCarrierFields.push({
          key: item.Key,
          isRequired: true,
          savedValue: item.Value // Store the Extra value (Extra1, Extra2, etc.)
        });
      });
    }

    // Also add any additional fields from carrierColumns that aren't in iAColumnMapping
    carrierColumns.forEach(col => {
      if (!allCarrierFields.some(f => f.key === col.key)) {
        allCarrierFields.push({
          key: col.key,
          isRequired: col.isRequired || true,
          savedValue: null
        });
      }
    });

    // Auto-map based on iAColumnMapping
    const savedMatches = [];

    if (iAColumnMapping && iAColumnMapping.length > 0) {
      uploadedColumns.forEach(uploadedCol => {
        // Check if this uploaded column matches any KEY in iAColumnMapping
        const savedMatch = iAColumnMapping.find(
          item =>
            item &&
            item.Key &&
            item.Key.toLowerCase() ===
              (uploadedCol && uploadedCol.toLowerCase())
        );

        if (savedMatch) {
          // Find in our complete carrier fields list
          const matchingCarrierField = allCarrierFields.find(
            field =>
              field &&
              field.key &&
              field.key.toLowerCase() ===
                (savedMatch.Key && savedMatch.Key.toLowerCase())
          );

          if (matchingCarrierField) {
            savedMatches.push({
              carrierField: matchingCarrierField.key,
              uploadedField: uploadedCol,
              isMapped: true,
              isRequired: matchingCarrierField.isRequired,
              isExactMatch: false,
              isSavedMapping: true,
              savedValue: matchingCarrierField.savedValue // Store the Extra value
            });
            mappedCount++;
            mappedUploadedCols.add(uploadedCol);
          }
        }
      });
    }

    // Add saved matches first
    mappings.push(...savedMatches);

    // SECOND: Find exact name matches for remaining columns
    const exactMatches = [];
    const unmatchedUploadedCols = [];

    uploadedColumns.forEach(uploadedCol => {
      if (mappedUploadedCols.has(uploadedCol)) return;

      // Check against all carrier fields
      const matchingCarrierField = allCarrierFields.find(
        field =>
          field &&
          field.key &&
          uploadedCol &&
          field.key.toLowerCase() === uploadedCol.toLowerCase()
      );

      if (matchingCarrierField) {
        exactMatches.push({
          carrierField: matchingCarrierField.key,
          uploadedField: uploadedCol,
          isMapped: true,
          isRequired: matchingCarrierField.isRequired,
          isExactMatch: true,
          savedValue: matchingCarrierField.savedValue
        });
        mappedCount++;
        mappedUploadedCols.add(uploadedCol);
      } else {
        unmatchedUploadedCols.push(uploadedCol);
      }
    });

    mappings.push(...exactMatches);

    // Add remaining uploaded columns that weren't matched
    unmatchedUploadedCols.forEach(uploadedCol => {
      mappings.push({
        carrierField: '',
        uploadedField: uploadedCol,
        isMapped: false,
        isRequired: false,
        isExactMatch: false,
        isSavedMapping: false,
        savedValue: null
      });
    });

    // Add carrier fields that weren't matched at all
    const mappedCarrierFields = new Set(
      mappings.filter(m => m.carrierField).map(m => m.carrierField)
    );

    const unmatchedCarrierFields = allCarrierFields.filter(
      field => !mappedCarrierFields.has(field.key)
    );

    // Add them as unmapped placeholder rows
    unmatchedCarrierFields.forEach(field => {
      mappings.push({
        carrierField: field.key,
        uploadedField: '',
        isMapped: false,
        isRequired: field.isRequired,
        isExactMatch: false,
        isCarrierOnly: true,
        savedValue: field.savedValue
      });
    });

    setColumnMappings(mappings);
    setMappedCount(mappedCount);

    const allMapped = allCarrierFields.every(field =>
      mappings.some(m => m.carrierField === field.key && m.isMapped)
    );
    setIsMappingComplete(allMapped);
  };

  // Format the value to 2 decimal places if it's a number
  const formatValue = value => {
    if (value === null || value === undefined || value === '') return value;

    // Convert to string and check if it's a number
    const stringValue = String(value);

    // Check if it's a number (including currency strings)
    const numericStr = stringValue.replace(/[$,]/g, '');
    const num = parseFloat(numericStr);

    if (!isNaN(num)) {
      // Check if original had currency symbol
      const hasCurrency = stringValue.includes('$');
      // Format to 2 decimal places - this fixes 23.340000000000003 → 23.34
      const formatted = num.toFixed(2);
      return hasCurrency ? `$${formatted}` : formatted;
    }
    return value;
  };
  const groupAndSumRowsByProNumber = (transformedData, previewColumnsData) => {
    if (!transformedData || transformedData.length === 0) return [];

    // Helper function to format numbers appropriately (preserve integers)
    const formatNumberAppropriately = value => {
      if (value === null || value === undefined || value === '') return '';

      // If it's already a string with a specific format, return as-is
      if (typeof value === 'string') {
        // Check if it's a date (MM/DD/YYYY)
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
          return value;
        }
      }

      const num = parseFloat(String(value).replace(/[$,]/g, ''));
      if (isNaN(num)) return String(value);

      // Check if it's a whole number (integer)
      if (Number.isInteger(num)) {
        return num.toString(); // Return as integer without decimal places
      }

      // Check if it has decimal places
      const decimalPlaces = (num.toString().split('.')[1] || '').length;
      if (decimalPlaces > 0) {
        // If it has decimals, format to 2 places
        return num.toFixed(2);
      }

      return num.toString();
    };

    // Helper function to check if a column is a date column - ONLY by column name
    const isDateColumn = col => {
      const key = col.key.toLowerCase();
      // Only check column name, never check values
      return (
        key.includes('date') ||
        key.includes('time') ||
        key === 'pdate' || // Specifically match PDATE
        key.includes('delivery') ||
        key.includes('pickup') ||
        key.includes('scheduled') ||
        key.includes('created') ||
        key.includes('updated')
      );
    };

    // Find the PRO number column
    const proNumberColumn = previewColumnsData.find(col => {
      const key = col.key.toLowerCase();
      return (
        key.includes('pro') ||
        key.includes('tracking') ||
        key.includes('pronumber') ||
        key.includes('pro#')
      );
    });

    if (!proNumberColumn) return transformedData;

    // Separate date columns and charge columns
    const dateColumns = [];
    const chargeColumns = [];

    previewColumnsData.forEach(col => {
      if (col.key === proNumberColumn.key) return;

      if (isDateColumn(col)) {
        dateColumns.push(col);
      } else {
        // Check if it's a numeric column (potential charge)
        let hasValidNumber = false;
        const sampleSize = Math.min(3, transformedData.length);

        for (let i = 0; i < sampleSize; i++) {
          const value = transformedData[i][col.key];
          if (value === null || value === undefined || value === '') continue;

          const numericStr = String(value).replace(/[$,]/g, '');
          const num = parseFloat(numericStr);

          if (!isNaN(num)) {
            hasValidNumber = true;
            break;
          }
        }

        if (hasValidNumber) {
          chargeColumns.push(col);
        }
      }
    });

    console.log(
      'Date columns (will be preserved):',
      dateColumns.map(c => c.key)
    );
    console.log(
      'Charge columns (will be summed):',
      chargeColumns.map(c => c.key)
    );

    // Group rows by PRO number
    const groupedMap = new Map();

    transformedData.forEach(row => {
      const proNumber = row[proNumberColumn.key];

      if (!proNumber || proNumber === '') {
        const key = `no-pro-${Math.random()}`;
        groupedMap.set(key, {
          rows: [row],
          isGrouped: false,
          proNumber: null
        });
        return;
      }

      const proNumberStr = String(proNumber).trim();

      if (!groupedMap.has(proNumberStr)) {
        groupedMap.set(proNumberStr, {
          rows: [row],
          isGrouped: false,
          proNumber: proNumberStr
        });
      } else {
        const group = groupedMap.get(proNumberStr);
        group.rows.push(row);
        group.isGrouped = true;
      }
    });

    // Create result array with summed values
    const result = [];

    groupedMap.forEach(group => {
      if (group.rows.length === 1) {
        const row = { ...group.rows[0] };

        // Format charge column values appropriately
        chargeColumns.forEach(col => {
          if (row[col.key] !== undefined && row[col.key] !== null) {
            row[col.key] = formatNumberAppropriately(row[col.key]);
          }
        });

        row._rowCount = 1;
        row._isGrouped = false;
        result.push(row);
      } else {
        // Start with first row
        const summedRow = { ...group.rows[0] };

        summedRow._originalRows = [...group.rows];
        summedRow._rowCount = group.rows.length;
        summedRow._isGrouped = true;

        // Track which charge columns have changed
        const changedColumns = new Set();

        // Identify which charge columns actually have different values across rows
        chargeColumns.forEach(col => {
          const values = group.rows.map(r => {
            const val = String(r[col.key] || '0').replace(/[$,]/g, '');
            return parseFloat(val) || 0;
          });

          // Check if all values are the same
          const firstValue = values[0];
          const allSame = values.every(v => Math.abs(v - firstValue) < 0.001);

          if (!allSame) {
            changedColumns.add(col.key);
          }
        });

        // Apply formula only for charge columns that changed
        for (let i = 1; i < group.rows.length; i++) {
          const currentRow = group.rows[i];

          chargeColumns.forEach(col => {
            if (!changedColumns.has(col.key)) return;

            const currentVal = String(summedRow[col.key] || '0').replace(
              /[$,]/g,
              ''
            );
            const newVal = String(currentRow[col.key] || '0').replace(
              /[$,]/g,
              ''
            );

            const baseValue = parseFloat(currentVal) || 0;
            const newValue = parseFloat(newVal) || 0;

            // Formula: baseValue + (newValue - baseValue)
            const result = baseValue + (newValue - baseValue);

            // Store the raw number - formatting will be applied later
            summedRow[col.key] = result;
          });
        }

        // For charge columns that didn't change, keep first row value
        chargeColumns.forEach(col => {
          if (
            !changedColumns.has(col.key) &&
            summedRow[col.key] !== undefined
          ) {
            // Keep as-is, will be formatted
          }
        });

        // Apply appropriate formatting to all charge columns
        chargeColumns.forEach(col => {
          if (summedRow[col.key] !== undefined) {
            summedRow[col.key] = formatNumberAppropriately(summedRow[col.key]);
          }
        });

        // Add metadata about which columns were summed
        summedRow._changedColumns = Array.from(changedColumns);
        result.push(summedRow);
      }
    });

    return result;
  };
  // FIXED: Prepare preview table data WITHOUT date parsing
  const preparePreviewTableData = () => {
    if (!rowsData.length || !columnMappings.length) return;

    // Transform data based on mappings
    const transformedData = rowsData.map(row => {
      const newRow = {};
      columnMappings.forEach(mapping => {
        if (mapping.isMapped && mapping.carrierField && mapping.uploadedField) {
          newRow[mapping.carrierField] = row[mapping.uploadedField];
        }
      });
      return newRow;
    });

    // Get mapped columns
    const mappedColumns = columnMappings
      .filter(m => m.isMapped && m.carrierField)
      .map(m => ({
        key: m.carrierField,
        label: m.carrierField,
        required: m.isRequired,
        uploadedField: m.uploadedField,
        savedValue: m.savedValue
      }));

    // Group and sum rows by PRO number
    const groupedData = groupAndSumRowsByProNumber(
      transformedData,
      mappedColumns
    );

    setPreviewTableData(groupedData);
    setPreviewColumnsData(mappedColumns);
    setShowPreviewTable(true);
  };

  // NEW: Handle preview table sorting
  const handlePreviewSort = key => {
    let direction = 'asc';
    if (
      previewSortConfig.key === key &&
      previewSortConfig.direction === 'asc'
    ) {
      direction = 'desc';
    }
    setPreviewSortConfig({ key, direction });
  };

  // NEW: Get sorted and filtered preview data
  const getSortedFilteredPreviewData = () => {
    let filteredData = [...previewTableData];

    // Apply search filter

    // Apply sorting
    if (previewSortConfig.key) {
      filteredData.sort((a, b) => {
        const aValue = a[previewSortConfig.key];
        const bValue = b[previewSortConfig.key];

        if (aValue === bValue) return 0;

        const comparison = String(aValue).localeCompare(
          String(bValue),
          undefined,
          { numeric: true }
        );

        return previewSortConfig.direction === 'asc' ? comparison : -comparison;
      });
    }

    return filteredData;
  };

  const getColumnMappingInfo = carrierField => {
    const mapping = columnMappings.find(
      m => m.carrierField === carrierField && m.isMapped
    );

    if (!mapping) return null;

    return {
      uploadedField: mapping.uploadedField,
      isExactMatch: mapping.isExactMatch || false,
      isSavedMapping: mapping.isSavedMapping || false,
      isRequired: mapping.isRequired,
      savedValue: mapping.savedValue || null // This will be "Extra1", "Extra2", etc.
    };
  };

  useEffect(() => {
    if (previewColumnsData?.length) {
      const mapping = previewColumnsData
        .map(column => {
          const mappingInfo = getColumnMappingInfo(column.key);
          if (mappingInfo) {
            return {
              key: mappingInfo.uploadedField,
              value: mappingInfo.savedValue ?? column.key
            };
          }
          return null;
        })
        .filter(item => item !== null); // Remove null values

      setCustomMapping(mapping);
    }
  }, [previewColumnsData]);

  // Update the TableCell rendering for date columns
  const totalOriginalRows = previewTableData.reduce(
    (sum, row) => sum + (row._rowCount || 1),
    0
  );
  const groupedTotalRows = previewTableData.reduce(
    (sum, row) => sum + (row._isGrouped ? row._rowCount : 0),
    0
  );
  function getUniqueByProNumber(data) {
    // Create a Map to store unique records by PRO number
    const uniqueMap = new Map();

    data.forEach(item => {
      const proNumber = item.fileProNumber || item.apiProNumber;
      if (proNumber && !uniqueMap.has(proNumber)) {
        uniqueMap.set(proNumber, item);
      }
    });

    return Array.from(uniqueMap.values());
  }
  const PreviewDataTable = () => {
    const sortedFilteredData = getSortedFilteredPreviewData();

    // Calculate summary statistics
    const groupedRowsCount = previewTableData.filter(
      row => row._isGrouped
    ).length;

    const handleExportToExcel = () => {
      try {
        // Prepare export data without the internal _ fields
        const exportData = previewTableData.map(row => {
          const cleanRow = {};
          previewColumnsData.forEach(col => {
            let value = row[col.key];

            // Ensure all values are strings
            if (value === null || value === undefined) {
              value = '';
            } else if (typeof value === 'number') {
              // Format numbers to 2 decimal places
              value = value.toFixed(2);
            } else {
              value = String(value);
            }

            cleanRow[col.key] = value;
          });
          return cleanRow;
        });

        console.log('Export data prepared:', exportData.length, 'rows');

        // Create workbook and worksheet using simpler method
        const wb = XLSX.utils.book_new();

        // Convert JSON to worksheet
        const ws = XLSX.utils.json_to_sheet(exportData);

        // Set column widths
        const maxWidth = 30;
        const wscols = previewColumnsData.map(() => ({ wch: maxWidth }));
        ws['!cols'] = wscols;

        // Add the worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Mapped Data');

        // Create metadata as a separate sheet
        const metadata = [
          ['MAPPED DATA EXPORT'],
          [''],
          ['Export Date:', new Date().toLocaleString()],
          ['Carrier:', carrierName?.name || 'Unknown'],
          ['Original Rows:', totalOriginalRows.toString()],
          ['Grouped Rows:', previewTableData.length.toString()],
          ['Rows Grouped:', groupedTotalRows.toString()],
          [''],
          ['GROUPING INFORMATION:'],
          ['PRO Number', 'Original Rows', 'Is Grouped']
        ];

        // Add grouped rows data
        previewTableData
          .filter(row => row._isGrouped)
          .forEach(row => {
            const proNumberColumn = previewColumnsData.find(
              col =>
                col.key.toLowerCase().includes('pro') ||
                col.key.toLowerCase().includes('tracking')
            );
            metadata.push([
              String(row[proNumberColumn?.key] || 'N/A'),
              String(row._rowCount || 1),
              'Yes'
            ]);
          });

        const wsMeta = XLSX.utils.aoa_to_sheet(metadata);
        XLSX.utils.book_append_sheet(wb, wsMeta, 'Grouping Info');

        // Generate Excel file as binary string
        const wbout = XLSX.write(wb, {
          bookType: 'xlsx',
          type: 'binary'
        });

        // Convert binary string to array buffer
        function s2ab(s) {
          const buf = new ArrayBuffer(s.length);
          const view = new Uint8Array(buf);
          for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
          return buf;
        }

        const buf = s2ab(wbout);

        // Create blob and download
        const blob = new Blob([buf], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const fileName = `Mapped_Data_${carrierName?.name || 'Export'}_${
          new Date().toISOString().split('T')[0]
        }.xlsx`;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        successToast('Data exported to Excel successfully!');
      } catch (error) {
        console.error('Export error:', error);
        ErrorToast('Failed to export data to Excel: ' + error.message);
      }
    };
    return (
      <Dialog
        open={showPreviewTable}
        onClose={() => setShowPreviewTable(false)}
        maxWidth='xl'
        fullWidth
        PaperProps={{
          sx: {
            maxWidth: '95vw',
            maxHeight: '90vh',
            m: 1
          }
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 1,
            pt: 2,
            borderBottom: '1px solid #e0e0e0'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              flexWrap: 'wrap'
            }}
          >
            <Typography variant='h6' fontSize='1.1rem' fontWeight='600'>
              Preview Data Before Import
            </Typography>
            <Chip
              label={`${previewTableData.length} grouped rows`}
              size='small'
              color='primary'
              title={`From ${totalOriginalRows} original rows`}
            />
            {groupedRowsCount > 0 && (
              <Chip
                label={`${groupedRowsCount} PRO#s with multiple rows`}
                size='small'
                color='warning'
                title={`${groupedTotalRows} original rows grouped`}
              />
            )}
            <Chip
              label={`${carrierName?.name || 'Carrier'}`}
              size='small'
              variant='outlined'
              color='secondary'
            />
          </Box>
          <IconButton
            onClick={() => setShowPreviewTable(false)}
            size='small'
            sx={{ p: 0.5 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          {/* Column Mapping Summary */}
          <Paper
            elevation={0}
            sx={{ p: 2, mb: 2, bgcolor: '#f8f9fa', borderRadius: 1 }}
          >
            <Typography variant='subtitle2' fontWeight='600' sx={{ mb: 1 }}>
              Column Mappings:
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {previewColumnsData.map(column => {
                const mappingInfo = getColumnMappingInfo(column.key);
                return mappingInfo ? (
                  <Tooltip
                    key={column.key}
                    title={
                      <Box>
                        <div>
                          <strong>Mapping:</strong> {mappingInfo.uploadedField}{' '}
                          → {column.key}
                        </div>
                        <div>
                          <strong>Type:</strong>{' '}
                          {mappingInfo.isExactMatch
                            ? 'Exact Match'
                            : mappingInfo.isSavedMapping
                              ? `Saved Mapping (from ${mappingInfo.savedValue})`
                              : 'Manual Mapping'}
                        </div>
                      </Box>
                    }
                    arrow
                  >
                    <Chip
                      size='small'
                      label={
                        mappingInfo.isSavedMapping &&
                        mappingInfo.savedValue &&
                        mappingInfo.savedValue !== mappingInfo.uploadedField
                          ? `${mappingInfo.uploadedField} → ${column.key} (from ${mappingInfo.savedValue})`
                          : `${mappingInfo.uploadedField} → ${column.key}`
                      }
                      color={
                        mappingInfo.isExactMatch
                          ? 'success'
                          : mappingInfo.isSavedMapping
                            ? 'info'
                            : 'primary'
                      }
                      variant='outlined'
                      icon={
                        mappingInfo.isExactMatch ? (
                          <AutoAwesomeIcon fontSize='small' />
                        ) : mappingInfo.isSavedMapping ? (
                          <BookmarkAddedIcon fontSize='small' />
                        ) : undefined
                      }
                    />
                  </Tooltip>
                ) : null;
              })}
            </Box>
          </Paper>

          {/* Data Table */}
          <TableContainer
            sx={{
              maxHeight: '50vh',
              overflow: 'auto',
              border: '1px solid #e0e0e0'
            }}
          >
            <Table size='small' stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: 'bold',
                      bgcolor: '#f5f5f5',
                      position: 'sticky',
                      left: 0,
                      zIndex: 3,
                      minWidth: 60
                    }}
                  >
                    #
                  </TableCell>
                  {previewColumnsData.map(column => {
                    const mappingInfo = getColumnMappingInfo(column.key);
                    const isProColumn =
                      column.key.toLowerCase().includes('pro') ||
                      column.key.toLowerCase().includes('tracking');

                    return (
                      <TableCell
                        key={column.key}
                        sx={{
                          fontWeight: 'bold',
                          bgcolor: isProColumn ? '#e8f5e8' : '#f5f5f5',
                          minWidth: 180,
                          cursor: 'pointer',
                          '&:hover': {
                            bgcolor: isProColumn ? '#c8e6c9' : '#e0e0e0'
                          },
                          borderLeft: isProColumn ? '2px solid #4caf50' : 'none'
                        }}
                        onClick={() => handlePreviewSort(column.key)}
                      >
                        <Box>
                          {/* Column Header */}
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              mb: 0.5
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5
                              }}
                            >
                              <Typography variant='body2' fontWeight='600'>
                                {column.label}
                              </Typography>
                              {column.required && (
                                <Typography variant='caption' color='error'>
                                  *
                                </Typography>
                              )}
                            </Box>
                            {previewSortConfig.key === column.key &&
                              (previewSortConfig.direction === 'asc' ? (
                                <ArrowUpward fontSize='small' />
                              ) : (
                                <ArrowDownward fontSize='small' />
                              ))}
                          </Box>

                          {/* Mapping Info */}
                          {mappingInfo && (
                            <Typography
                              variant='caption'
                              color='text.secondary'
                              sx={{
                                fontSize: '0.7rem',
                                display: 'block',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                              }}
                            >
                              ← {mappingInfo.uploadedField}
                            </Typography>
                          )}
                        </Box>
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedFilteredData.length > 0 ? (
                  sortedFilteredData.map((row, rowIndex) => (
                    <TableRow
                      key={rowIndex}
                      sx={{
                        '&:hover': { bgcolor: '#f9f9f9' },
                        ...(row._isGrouped && {
                          bgcolor: '#fff3e0',
                          '&:hover': { bgcolor: '#ffe0b2' },
                          borderLeft: '4px solid #ff9800'
                        })
                      }}
                    >
                      <TableCell
                        sx={{
                          fontWeight: 'bold',
                          bgcolor: row._isGrouped ? '#fff3e0' : '#f5f5f5',
                          position: 'sticky',
                          left: 0,
                          zIndex: 2,
                          minWidth: 60
                        }}
                      >
                        <Box
                          sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                        >
                          {rowIndex + 1}
                          {row._isGrouped && (
                            <Chip
                              label={`${row._rowCount} rows grouped`}
                              size='small'
                              color='warning'
                              sx={{ height: 20, fontSize: '0.65rem', ml: 1 }}
                            />
                          )}
                        </Box>
                      </TableCell>
                      {previewColumnsData.map(column => {
                        const cellValue = row[column.key];

                        // Dynamically determine if this column was summed (changed across rows)
                        const wasSummed =
                          row._isGrouped &&
                          row._changedColumns?.includes(column.key);

                        // For display, we still want to highlight numeric columns that changed
                        const isChargeColumn =
                          wasSummed ||
                          (() => {
                            // Skip PRO number column
                            if (
                              column.key.toLowerCase().includes('pro') ||
                              column.key.toLowerCase().includes('tracking')
                            ) {
                              return false;
                            }

                            // Check if the value looks numeric (including currency format)
                            const sampleValue = String(cellValue || '').replace(
                              /[$,]/g,
                              ''
                            );
                            const num = parseFloat(sampleValue);
                            return !isNaN(num) && sampleValue.length > 0;
                          })();

                        return (
                          <TableCell
                            key={`${rowIndex}-${column.key}`}
                            sx={{
                              bgcolor: row._isGrouped ? '#fff3e0' : 'inherit',
                              ...(row._isGrouped &&
                                wasSummed && {
                                  // Only highlight if it was actually summed
                                  color: '#e65100',
                                  fontWeight: 'bold'
                                })
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                              }}
                            >
                              <span
                                style={{
                                  display: 'block',
                                  maxWidth: 150,
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                {cellValue}
                              </span>
                              {row._isGrouped &&
                                wasSummed && ( // Only show (sum) if it was actually summed
                                  <span
                                    style={{
                                      fontSize: '0.7rem',
                                      color: '#e65100',
                                      backgroundColor: '#fff3e0',
                                      padding: '2px 6px',
                                      borderRadius: '12px',
                                      border: '1px solid #ffb74d',
                                      whiteSpace: 'nowrap'
                                    }}
                                  >
                                    sum of {row._rowCount} records
                                  </span>
                                )}
                            </Box>
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={previewColumnsData.length + 1}
                      align='center'
                      sx={{ py: 4 }}
                    >
                      <Typography color='text.secondary'>
                        No data available
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>

        <DialogActions sx={{ p: 2, borderTop: '1px solid #e0e0e0' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button
              onClick={handleExportToExcel}
              variant='outlined'
              size='small'
              startIcon={<DownloadIcon />}
              color='secondary'
            >
              Export to Excel
            </Button>
            <Button
              onClick={() => setShowPreviewTable(false)}
              variant='outlined'
              size='small'
              startIcon={<CloseIcon />}
            >
              Cancel
            </Button>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button
              variant='contained'
              color='primary'
              onClick={handleFinalImport}
              size='small'
              startIcon={<CheckCircleIcon />}
              disabled={shipmentsLoader}
            >
              {shipmentsLoader ? (
                <CircularProgress size={20} sx={{ color: 'white', mr: 1 }} />
              ) : null}
              Confirm & Import Data
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    );
  };

  // FIXED: Final import function that preserves date formats
  const handleUpdateIAColMapReq = () => {
    // Transform customMapping to use carrier keys
    const mappedCustomMapping = customMapping.map(m => {
      // Find the carrier key for this mapping
      const carrierField = apiCarrierColsDetails.find(
        col => col.key === m.value || col.caption === m.value
      );

      return {
        key: m.key, // This is the uploaded field name
        value: carrierField?.key || m.value // Use carrier key, fallback to value
      };
    });

    const iAObject = {
      agencyId: AgencyID ?? 0,
      carrierId: carrierName?.carrierId ?? 0,
      customMapping: mappedCustomMapping
    };

    UpdateIAColumnMapping(iAObject)
      .then(res => {
        if (res.status === 200) {
          console.log('Column mapping updated successfully', res);
        }
      })
      .catch(err => ErrorToast('Failed to update column mapping!'));
  };

  const handleFinalImport = () => {
    if (!carrierName?.carrierId) {
      ErrorToast('Invalid carrier configuration!');
      return;
    }
    setShipmentsLoader(true);
    handleUpdateIAColMapReq();

    // Helper function to check if a value is a date
    const isDateValue = value => {
      if (!value || typeof value !== 'string') return false;
      // Check for MM/DD/YYYY format
      return /^\d{2}\/\d{2}\/\d{4}$/.test(value);
    };

    // FIX: Ensure ALL values are strings before creating worksheet
    const transformedData = previewTableData.map(row => {
      const newRow = {};
      previewColumnsData.forEach(column => {
        const carrierField = apiCarrierColsDetails.find(
          col => col.key === column.key || col.caption === column.key
        );
        const outputKey = carrierField?.key || column.key;

        // Get the cell value
        let cellValue = row[column.key];

        if (cellValue === null || cellValue === undefined) {
          cellValue = '';
        } else if (typeof cellValue === 'number') {
          // Check if this might be a date column by name
          const isDateCol =
            column.key.toLowerCase().includes('date') ||
            column.key.toLowerCase().includes('time') ||
            column.key.toLowerCase().includes('delivery') ||
            column.key.toLowerCase().includes('pickup');

          if (isDateCol) {
            // If it's a date column but we have a number, try to convert from Excel serial
            try {
              const excelEpoch = new Date(Date.UTC(1899, 11, 30));
              let excelDate = cellValue;
              if (excelDate >= 60) excelDate -= 1;
              const jsDate = new Date(
                excelEpoch.getTime() + (excelDate - 1) * 86400000
              );
              const month = String(jsDate.getUTCMonth() + 1).padStart(2, '0');
              const day = String(jsDate.getUTCDate()).padStart(2, '0');
              const year = jsDate.getUTCFullYear();
              cellValue = `${month}/${day}/${year}`;
            } catch (e) {
              cellValue = String(cellValue);
            }
          } else if (
            column.key.toLowerCase().includes('charge') ||
            column.key.toLowerCase().includes('net') ||
            column.key.toLowerCase().includes('discount') ||
            column.key.toLowerCase().includes('fuel')
          ) {
            // Format numbers to 2 decimal places for charge columns
            cellValue = Number(cellValue).toFixed(2);
          } else {
            cellValue = String(cellValue);
          }
        } else {
          cellValue = String(cellValue).trim();
        }

        newRow[outputKey] = cellValue;
      });
      return newRow;
    });

    console.log('Transformed data with carrier keys:', transformedData);

    const extension = fileName.split('.').pop().toLowerCase();
    let finalFile;

    if (extension === 'csv') {
      const csvData = Papa.unparse(transformedData);
      const csvBlob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
      finalFile = new File([csvBlob], fileName, { type: 'text/csv' });
    } else if (extension === 'xls' || extension === 'xlsx') {
      // Create worksheet WITHOUT cellStyles option
      const worksheet = XLSX.utils.json_to_sheet(transformedData, {
        cellDates: false,
        dateNF: '@'
      });

      // Ensure all cells have string type AND string value
      if (worksheet['!ref']) {
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        for (let C = range.s.c; C <= range.e.c; ++C) {
          for (let R = range.s.r; R <= range.e.r; ++R) {
            const cell_address = { c: C, r: R };
            const cell_ref = XLSX.utils.encode_cell(cell_address);
            if (worksheet[cell_ref]) {
              // Force string type
              worksheet[cell_ref].t = 's';
              // Force string value
              worksheet[cell_ref].v = String(worksheet[cell_ref].v || '');
              // Clear formula if any
              delete worksheet[cell_ref].f;
              delete worksheet[cell_ref].w;
            }
          }
        }
      }

      // Set column widths
      const maxWidth = 30;
      worksheet['!cols'] = previewColumnsData.map(() => ({ wch: maxWidth }));

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      // Remove cellStyles option
      const wbout = XLSX.write(workbook, {
        bookType: extension,
        type: 'array',
        cellStyles: false
      });

      const mimeType =
        extension === 'xls'
          ? 'application/vnd.ms-excel'
          : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      const excelBlob = new Blob([wbout], { type: mimeType });
      finalFile = new File([excelBlob], fileName, { type: mimeType });
    } else {
      ErrorToast('Unsupported file type');
      setShipmentsLoader(false);
      return;
    }

    console.log('File created:', finalFile.name, finalFile.size, 'bytes');

    // Call the API
    const formData = new FormData();
    formData.append('file', finalFile);

    ImportInvoiceAuditShipments(carrierName?.carrierId, formData)
      .then(res => {
        if (res?.status === 200 && res?.data) {
          successToast('Data imported successfully!');
          handleMatchedNumbers(res.data);
          setShowPreviewTable(false);
        } else {
          ErrorToast('Unexpected API response!');
        }
      })
      .catch(err => {
        console.error('Import API error:', err);
        ErrorToast(err?.response?.data || 'API Error occurred!');
      })
      .finally(() => {
        setShipmentsLoader(false);
      });
  };

  // Updated handleFileImport
  // Updated handleFileImport
  const handleFileImport = e => {
    const importedFile = e.target.files[0];

    if (importedFile) {
      const fileName = importedFile.name.toLowerCase();
      setFileName(fileName);

      const isCSV = fileName.endsWith('.csv');
      const isExcel = fileName.endsWith('.xls') || fileName.endsWith('.xlsx');

      if (isCSV) {
        const reader = new FileReader();
        reader.onload = e => {
          try {
            const text = e.target.result;

            // Parse CSV with explicit string conversion
            const result = Papa.parse(text, {
              header: true,
              skipEmptyLines: true,
              transform: (value, field) => {
                // Convert all values to strings and trim
                if (value === null || value === undefined) return '';
                return String(value).trim();
              }
            });

            // Get headers and ensure they're strings
            const headers =
              result.meta.fields
                ?.map(h => (h ? String(h).trim() : ''))
                .filter(h => h !== '') || [];

            console.log('CSV Headers:', headers);

            // Process each row to ensure all values are strings
            const processedData = result.data.map(row => {
              const newRow = {};
              headers.forEach(header => {
                let value = row[header];
                // Convert to string, handle null/undefined
                if (value === null || value === undefined) {
                  value = '';
                } else {
                  value = String(value).trim();
                }
                newRow[header] = value;
              });
              return newRow;
            });

            // Filter rows that have PRO number or BOL number
            const filteredData = filterRows(processedData);

            console.log('Processed CSV rows:', filteredData.length);

            // Initialize mappings if carrier columns are available
            if (apiCarrierColsDetails.length > 0) {
              initializeColumnMappings(apiCarrierColsDetails, headers);
              setShowMappingDialog(true);
            } else if (carrierName) {
              GetCarrierImportCol(carrierName.carrierId)
                .then(res => {
                  const carrierColumns = res.data.data.iaColumnMappingArray;
                  setApiCarrierColsDetails(carrierColumns);
                  initializeColumnMappings(carrierColumns, headers);
                  setShowMappingDialog(true);
                })
                .catch(err => {
                  ErrorToast('Failed to load carrier column details');
                });
            }

            setColumns(headers);
            setRowsData(filteredData);
            setFileNameErr(false);
          } catch (error) {
            console.error('CSV parsing error:', error);
            ErrorToast('Error parsing CSV file');
            setFileNameErr(true);
          }
        };

        reader.readAsText(importedFile);
      } else if (isExcel) {
        const reader = new FileReader();
        reader.onload = e => {
          try {
            const data = new Uint8Array(e.target.result);

            // Read workbook with specific options
            const workbook = XLSX.read(data, {
              type: 'array',
              cellText: true,
              cellDates: false,
              raw: true
            });

            const sheetName = workbook.SheetNames[0];
            let worksheet = workbook.Sheets[sheetName];

            // Fix Excel dates
            worksheet = fixExcelDates(worksheet);

            // Get ALL data as strings with header row
            const dataArray = XLSX.utils.sheet_to_json(worksheet, {
              header: 1,
              defval: '',
              raw: false
            });

            if (!dataArray || dataArray.length === 0) {
              ErrorToast('Excel file is empty');
              return;
            }

            // First row = headers - ensure they're strings
            const headers = (dataArray[0] || [])
              .map(h => {
                if (h === null || h === undefined) return '';
                return String(h).trim();
              })
              .filter(h => h !== '');

            console.log('Excel Headers:', headers);

            if (headers.length === 0) {
              ErrorToast('No headers found in Excel file');
              return;
            }

            // Convert rest to objects with string values
            const stringData = [];
            for (let i = 1; i < dataArray.length; i++) {
              const row = dataArray[i];
              if (!row || row.length === 0) continue;

              const obj = {};
              let hasData = false;

              headers.forEach((header, index) => {
                let value = row[index];
                // Convert to string, handle null/undefined
                if (value === null || value === undefined) {
                  value = '';
                } else {
                  value = String(value).trim();
                }
                obj[header] = value;
                if (value !== '') hasData = true;
              });

              // Only add rows that have some data
              if (hasData) {
                stringData.push(obj);
              }
            }

            console.log('Processed Excel rows:', stringData.length);

            // Filter rows that have PRO number or BOL number
            const filteredData = filterRows(stringData);

            // Initialize mappings...
            if (apiCarrierColsDetails.length > 0) {
              initializeColumnMappings(apiCarrierColsDetails, headers);
              setShowMappingDialog(true);
            }

            setColumns(headers);
            setRowsData(filteredData);
            setFileNameErr(false);
          } catch (error) {
            console.error('Excel parsing error:', error);
            ErrorToast('Error parsing Excel file');
            setFileNameErr(true);
          }
        };

        reader.readAsArrayBuffer(importedFile);
      } else {
        setFileName('');
        setFileNameErr(true);
        ErrorToast('Unsupported file type. Please upload CSV or Excel file.');
      }
    }
  };

  // Updated handleCarrierChange
  const handleCarrierChange = (event, newValue) => {
    event.stopPropagation();
    if (newValue) {
      setSelectCarrierLoading(true);
      const carrierId = newValue.carrierId;
      setCarrierName(newValue);

      GetCarrierImportCol(carrierId)
        .then(res => {
          setRowsData([]);
          setComparisonData([]);
          setSelectCarrierLoading(false);

          // Store detailed carrier column info
          const carrierColumns = res.data.data.iaColumnMappingArray;
          const iAColumnMapping = res.data.data.iaColumnMapping
            ? JSON.parse(res.data.data.iaColumnMapping)
            : carrierColumns;
          setApiCarrierColsDetails(carrierColumns);
          setIAColumnMapping(iAColumnMapping);

          const cols = getFilteredColumns(res.data.data.name, carrierColumns);

          setPreviewColumns(cols);
          res.status === 200 && carrierColumns.length === 1
            ? setFileNameErr(true)
            : setFileNameErr(false);

          setApiCarrierCols(
            carrierColumns.map(col => col.key.replace(/[\r\n]+/g, '').trim())
          );
        })
        .catch(err => {
          ErrorToast(
            `Failed to retrieve "${newValue?.name}" column names. (${err?.message})`
          );
          setSelectCarrierLoading(false);
          setCarrierName(null);
          setApiCarrierCols([]);
          setApiCarrierColsDetails([]);
        });
    }
  };

  const importedFileCoulmns = [
    {
      accessorKey: 'fileProNumber',
      id: 'fileProNumber',
      header: 'Carrier PRO/Tracking #',
      size: 250,
      enableColumnFilter: true,
      filterFn: (row, colID, filterValue) => {
        return row?.original?.fileProNumber
          ?.toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
            <br />
          </Box>
        </>
      )
    },
    {
      accessorKey: 'fileBolNumber',
      id: 'fileBolNumber',
      header: 'Carrier BOL Number',
      size: 10,
      enableColumnFilter: true,
      filterFn: (row, colID, filterValue) => {
        return row?.original?.fileBolNumber
          ?.toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
            <br />
          </Box>
        </>
      )
    },
    {
      accessorKey: 'apiProNumber',
      id: 'apiProNumber',
      header: 'TMS PRO/Tracking #',
      enableColumnFilter: true,
      size: 10,
      filterFn: (row, colID, filterValue) => {
        return row?.original?.apiProNumber
          ?.toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
            <br />
          </Box>
        </>
      )
    },
    {
      accessorKey: 'apiBolNumber',
      id: 'apiBolNumber',
      header: 'TMS BOL Number',
      enableColumnFilter: true,
      size: 10,
      filterFn: (row, colID, filterValue) => {
        return row?.original?.apiBolNumber
          ?.toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
            <br />
          </Box>
        </>
      )
    },
    {
      accessorKey: 'proNumberMatchedStatus',
      id: 'proNumberMatchedStatus',
      header: 'Matched Status',
      enableColumnFilter: true,
      size: 100,
      filterFn: (row, colID, filterValue) => {
        return row?.original?.proNumberMatchedStatus
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          {
            <Box sx={{ display: 'flex' }}>
              <Chip
                size='small'
                variant='filled'
                color={
                  row?.original?.proNumberMatchedStatus === 'PRO# Matched'
                    ? 'success'
                    : 'default'
                }
                label={row?.original?.proNumberMatchedStatus}
              />
            </Box>
          }
        </Box>
      )
    }
  ];

  const invoiceAuditColumns = [
    {
      accessorKey: 'carrierName',
      id: 'carrierName',
      header: 'Carrier Name',
      size: 50,
      filterFn: (row, colID, filterValue) => {
        return row.original.carrierName
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          {renderedCellValue && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <AvatarGroup sx={{}} spacing='small'>
                <Avatar
                  src={
                    row.original.carrierLogo
                      ? base_logo_url + row.original.carrierLogo
                      : NoLogo
                  }
                />
              </AvatarGroup>
              <span>{renderedCellValue}</span>
              <br />
            </Box>
          )}
        </>
      )
    },
    {
      accessorKey: 'proNumber',
      id: 'proNumber',
      header: 'PRO/Tracking #',
      size: 10,
      filterFn: (row, colID, filterValue) => {
        return row.original.proNumber
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
            <br />
          </Box>
        </>
      )
    },
    {
      accessorKey: 'bolNumber',
      id: 'bolNumber',
      header: 'BOL #',
      size: 10,
      filterFn: (row, colID, filterValue) => {
        return row.original.bolNumber
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
            <br />
          </Box>
        </>
      )
    },
    {
      accessorKey: 'quoteNumber',
      id: 'quoteNumber',
      header: 'Quotation #',
      size: 10,
      filterFn: (row, colID, filterValue) => {
        return row.original.quoteNumber
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span>{renderedCellValue}</span>
            <br />
          </Box>
        </>
      )
    },
    {
      accessorKey: 'shipmentCharges',
      id: 'shipmentCharges',
      header: 'TMS Booking Rate',
      size: 50,
      filterFn: (row, colID, filterValue) => {
        if (!filterValue) return true;

        const rawValue = row.original?.shipmentCharges;
        const directValue = parseFloat(rawValue);
        const isNumericFilter = !isNaN(parseFloat(filterValue));
        const filterStr = filterValue.toString().trim();
        const filterNumber = parseFloat(filterStr);

        const surchargeAmount =
          row.original?.surchargesList?.find(
            item => item.description === 'Surcharge'
          )?.amount?.amount || 0;
        const calculatedValue = directValue - surchargeAmount;

        if (isNumericFilter) {
          const isExactMatch =
            Math.abs(directValue - filterNumber) < 0.01 ||
            Math.abs(calculatedValue - filterNumber) < 0.01;

          if (isExactMatch) return true;
        }

        return (
          rawValue?.toString().includes(filterStr) ||
          calculatedValue?.toString().includes(filterStr)
        );
      },
      Cell: ({ row, table }) => {
        const surchargesList = row?.original?.surchargesList?.find(
          item => item.description === 'Surcharge'
        );
        const rawValue = surchargesList?.amount?.amount
          ? row.original?.shipmentCharges - surchargesList?.amount?.amount
          : row.original?.shipmentCharges;
        const invoiceStatus = row.original.iaStatus;
        const formattedValue = parseFloat(rawValue);

        const filterValue =
          table.getColumn('shipmentCharges').getFilterValue() || '';

        const isHighlighted =
          filterValue &&
          (row.original?.shipmentCharges.toString().includes(filterValue) ||
            formattedValue.toString().includes(filterValue));

        const diff = row.original?.shipmentCharges - row?.original?.iaNetCharge;
        const threshold = row.original.iaThreshold;

        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <span
              style={
                isHighlighted
                  ? {
                      backgroundColor: 'rgb(255, 203, 127)',
                      borderRadius: '20px',
                      width: '5vw',
                      textAlign: 'center'
                    }
                  : invoiceStatus === 'RESOLVED'
                    ? {
                        backgroundColor: 'rgb(18, 214, 47)',
                        borderRadius: '20px',
                        width: '5vw',
                        textAlign: 'center'
                      }
                    : {
                        backgroundColor: 'rgb(252, 78, 78)',
                        color: 'rgb(255, 255, 255)',
                        borderRadius: '20px',
                        width: '5vw',
                        textAlign: 'center'
                      }
              }
            >
              {!isNaN(formattedValue)
                ? `$${formattedValue.toFixed(2)}`
                : '$0.00'}
            </span>
          </Box>
        );
      }
    },

    {
      accessorKey: 'iaNetCharge',
      id: 'iaNetCharge',
      header: 'Carrier Total Rate',
      size: 10,
      filterFn: (row, colID, filterValue) => {
        if (!filterValue) return true;

        const filterStr = filterValue.toString().trim();
        const isNumericFilter = !isNaN(parseFloat(filterStr));
        const filterNumber = parseFloat(filterStr);

        const iaNetCharge = parseFloat(row.original.iaNetCharge);
        if (isNaN(iaNetCharge)) return false;

        if (isNumericFilter) {
          const isExactMatch = Math.abs(iaNetCharge - filterNumber) < 0.01;
          if (isExactMatch) return true;
        }

        return iaNetCharge.toString().includes(filterStr);
      },
      Cell: ({ row, table }) => {
        const rawValue = row.original.iaNetCharge;
        const formattedValue = parseFloat(rawValue);

        const filterValue =
          table.getColumn('iaNetCharge').getFilterValue() || '';
        const isHighlighted =
          filterValue && formattedValue.toFixed(2).includes(filterValue);
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <span
              style={
                isHighlighted ? { backgroundColor: 'rgb(255, 203, 127)' } : {}
              }
            >
              {!isNaN(formattedValue)
                ? `$${formattedValue.toFixed(2)}`
                : '$0.00'}
            </span>
          </Box>
        );
      }
    },
    {
      accessorKey: 'Difference',
      id: 'Difference',
      header: 'Difference',
      size: 10,
      filterFn: (row, colID, filterValue) => {
        if (!filterValue) return true;

        const filterStr = filterValue.toString().trim();
        const isNumericFilter = !isNaN(parseFloat(filterStr));
        const filterNumber = parseFloat(filterStr);

        const surchargesList = row.original?.surchargesList?.find(
          item => item.description === 'Surcharge'
        );
        const originalShipCharges = surchargesList?.amount?.amount
          ? row.original?.shipmentCharges - surchargesList.amount.amount
          : row.original?.shipmentCharges;

        const iaNetCharge = parseFloat(row.original?.iaNetCharge);
        const diff = Math.abs(iaNetCharge - originalShipCharges);

        if (isNumericFilter) {
          const isExactMatch =
            Math.abs(diff - filterNumber) < 0.01 ||
            Math.abs(iaNetCharge - filterNumber) < 0.01;

          if (isExactMatch) return true;
        }

        return (
          diff?.toString().includes(filterStr) ||
          iaNetCharge?.toString().includes(filterStr)
        );
      },
      Cell: ({ row, table }) => {
        const surchargesList = row?.original?.surchargesList?.find(
          item => item.description === 'Surcharge'
        );
        const originalShipCharges = surchargesList?.amount?.amount
          ? row.original?.shipmentCharges - surchargesList?.amount?.amount
          : row.original?.shipmentCharges;
        const diff = Math.abs(row.original.iaNetCharge - originalShipCharges);

        const filterValue =
          table.getColumn('Difference').getFilterValue() || '';

        const isHighlighted =
          filterValue &&
          (diff.toFixed(2).includes(filterValue) ||
            row.original.iaNetCharge.toFixed(2).includes(filterValue));
        const threshold = row.original.iaThreshold;
        const isOverThreshold = threshold !== undefined && diff > threshold;

        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <span
              style={
                isHighlighted
                  ? {
                      backgroundColor: 'rgb(255, 203, 127)',
                      borderRadius: '20px',
                      padding: '2px 8px'
                    }
                  : isOverThreshold
                    ? {
                        backgroundColor: 'rgb(252, 78, 78)',
                        color: 'white',
                        borderRadius: '20px',
                        padding: '2px 8px'
                      }
                    : {
                        backgroundColor: 'rgb(18, 214, 47)',
                        borderRadius: '20px',
                        padding: '2px 8px'
                      }
              }
            >
              {!isNaN(diff) ? `$${diff.toFixed(2)}` : '$0.00'}
            </span>
          </Box>
        );
      }
    },

    {
      accessorKey: 'iaThreshold',
      id: 'iaThreshold',
      header: 'Threshold Value',
      size: 10,
      filterFn: (row, colID, filterValue) => {
        const iaThreshold = parseFloat(row.original.iaThreshold);

        if (isNaN(iaThreshold)) return false;

        return iaThreshold.toString().includes(filterValue);
      },
      Cell: ({ row, table }) => {
        const rawValue = row.original.iaThreshold;

        const formattedValue = parseFloat(rawValue);

        const filterValue =
          table.getColumn('iaThreshold').getFilterValue() || '';
        const isHighlighted =
          filterValue && formattedValue.toString().includes(filterValue);
        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <span
              style={
                isHighlighted ? { backgroundColor: 'rgb(255, 203, 127)' } : {}
              }
            >
              {!isNaN(formattedValue) ? `$${formattedValue}` : '$0'}
            </span>
          </Box>
        );
      }
    }
  ];

  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const UserLoggedInEmail = useSelector(state => state.userDetails.email);

  const handleSuccesGetCarriers = res => {
    const TMSCarrierList = [
      'FedEx',
      'SAIA',
      'R and L Carriers',
      'ESTES',
      'XPO',
      'SEFL'
    ];
    const LTL = res.data.data.filter(items =>
      TMSCarrierList.includes(items.name)
    );
    setCarrierApiNames(LTL);
  };

  useEffect(() => {
    handleImportedData();
  }, []);

  useEffect(() => {
    const matchedCount = apiCarrierCols.filter(col =>
      columns.includes(col)
    ).length;
    setMatchedCount(matchedCount);
    const allColumnsMatched = apiCarrierCols.every(col =>
      columns.includes(col)
    );
    setAllColumnsMatched(allColumnsMatched);
  }, [columns, apiCarrierCols]);

  const handleImportClick = () => {
    fileInputRef.current.click();
  };

  const isNumericColumn = (index, typeArr) => {
    return typeArr[index]?.toUpperCase() === 'NUMBER';
  };

  const isStrictNumeric = (value, index, typeArr) => {
    const type = typeArr[index]?.toUpperCase();

    if (value === '' || value === null || value === undefined) return true;

    const valStr = String(value).trim();

    if (type === 'NUMBER') {
      if (valStr === '$') return false;

      const numberWithDollarPattern = /^-?\$?[\d,]+(\.\d+)?\$?$/;

      return numberWithDollarPattern.test(valStr);
    }

    if (type === 'STRING') {
      return valStr !== '$';
    }

    return false;
  };

  const markInvalidFields = (data, columns, typeArr) => {
    return data.map(row => {
      const newRow = { ...row };
      columns.forEach(({ accessorKey }, index) => {
        const value = row[accessorKey];
        if (!isStrictNumeric(value, index, typeArr)) {
          newRow[`${accessorKey}__invalid`] = true;
        }
      });
      return newRow;
    });
  };

  const filterRows = rows => {
    if (!rows || !Array.isArray(rows)) return [];

    return rows.filter(fileRows => {
      if (!fileRows || typeof fileRows !== 'object') return false;

      const fileProNumber =
        fileRows['Tracking Number'] ||
        fileRows['PRO Number'] ||
        fileRows['ProNumber'] ||
        fileRows['PRO#'] ||
        fileRows['PRO'] ||
        fileRows['PRO NUMBER'] ||
        fileRows['PRO #'] ||
        '';

      const fileBolNumber =
        fileRows['BOL Number'] ||
        fileRows['BOLNumber'] ||
        fileRows['BOL#'] ||
        fileRows['BL #'] ||
        fileRows['BOL'] ||
        '';

      // Return true if either PRO number or BOL number exists and is not empty
      return (
        (fileProNumber && String(fileProNumber).trim() !== '') ||
        (fileBolNumber && String(fileBolNumber).trim() !== '')
      );
    });
  };

  const getMimeType = fileName => {
    const ext = fileName.split('.').pop().toLowerCase();
    switch (ext) {
      case 'csv':
        return 'text/csv';
      case 'xls':
        return 'application/vnd.ms-excel';
      case 'xlsx':
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      default:
        return 'application/octet-stream';
    }
  };

  const finalizeData = (headers, filteredData, fileName) => {
    setColumns(headers);
    const validationErrors = markInvalidFields(
      filteredData,
      previewColumns,
      fileColTypes
    );
    setRowsData(validationErrors);
    setFileNameErr(false);

    const csv = Papa.unparse(filteredData);
    const mimeType = getMimeType(fileName);
    const csvBlob = new Blob([csv], { type: mimeType });
    const filteredFile = new File(
      [csvBlob],
      'filtered_upload.' + fileName.split('.').pop(),
      {
        type: mimeType
      }
    );

    setUploadedFile(filteredFile);
  };

  const getFilteredColumns = (carrier, apiColumns) => {
    const typeMap = Object.fromEntries(
      apiColumns.map(item => [item.key, item.value])
    );

    const cols = previewCols
      .filter(col => col.carrier === carrier && typeMap[col.header])
      .map(col => ({
        ...col,
        type: typeMap[col.header] || ''
      }));

    const finalColsType = cols.map(col => col.type);
    setFileColTypes(finalColsType);

    return cols;
  };

  const handleSuccessShipDetails = async (res, status) => {
    setDisputedShipments(res.data.data);
    setShipmentsLoader(false);
    if (status === 'import') {
      handleChange('event', 1);
    }
  };

  const handleMatchedNumbers = ApiResData => {
    const apiData = ApiResData?.data || [];
    const cleanedApiData = apiData.filter(
      rows => rows?.proNumber && rows.proNumber !== ''
    );
    setImportedOriginalApiRes(cleanedApiData);

    const tempArr = [];

    if (!Array.isArray(validRowsFile) || validRowsFile.length === 0) {
      ErrorToast('Uploaded file has no valid rows!');
      return;
    }

    validRowsFile.forEach(fileRows => {
      if (!fileRows || typeof fileRows !== 'object') return;

      const CHKDGT = fileRows['CHKDGT'] ?? '';

      // DYNAMIC: Find the PRO number field based on column mappings
      let fileProNumber = '';

      // Method 1: Get from column mappings (most reliable)
      const proMapping = columnMappings.find(m => {
        if (!m.isMapped || !m.carrierField) return false;
        const field = m.carrierField.toLowerCase();
        return (
          field.includes('pro') ||
          field.includes('tracking') ||
          field.includes('pronumber') ||
          field.includes('pro#')
        );
      });

      if (proMapping && proMapping.uploadedField) {
        // Use the mapped uploaded field name
        fileProNumber = fileRows[proMapping.uploadedField] || '';
      }

      // Method 2: If no mapping found, try carrier-specific labels
      if (!fileProNumber) {
        const carrierProLabel = getCarrierProLabel(carrierName?.name);

        // Try the carrier-specific label first
        if (carrierProLabel && carrierProLabel !== 'PRO/Tracking #') {
          fileProNumber = fileRows[carrierProLabel] || '';
        }

        // If still not found, try common variations
        if (!fileProNumber) {
          const possibleFields = [
            'Tracking Number',
            'PRO Number',
            'ProNumber',
            'PRO#',
            'PRO',
            'PRO NUMBER',
            'PRO #',
            'TrackingNumber',
            'PRO-Number',
            'Pro #',
            'Pronumber'
          ];

          for (const field of possibleFields) {
            if (fileRows[field]) {
              fileProNumber = fileRows[field];
              break;
            }
          }
        }
      }

      // Method 3: If still not found, try to find any field that looks like a PRO number
      if (!fileProNumber) {
        const possibleProFields = Object.keys(fileRows).filter(key => {
          const lowerKey = key.toLowerCase();
          return (
            lowerKey.includes('pro') ||
            lowerKey.includes('tracking') ||
            lowerKey.includes('pror') ||
            lowerKey.includes('pro#')
          );
        });

        if (possibleProFields.length > 0) {
          fileProNumber = fileRows[possibleProFields[0]] || '';
        }
      }

      if (typeof fileProNumber !== 'string' && fileProNumber != null) {
        fileProNumber = fileProNumber.toString();
      }

      const normalize = str => {
        if (!str) return '';
        return str
          .toString()
          .replace(/-/g, '') // Remove hyphens
          .replace(/\s+/g, '') // Remove all spaces
          .replace(/[^\w]/g, '') // Remove any non-word characters
          .trim()
          .toUpperCase(); // Case-insensitive matching
      };

      let cleanedProNumber = normalize(fileProNumber);

      // Special handling for SAIA carrier
      if (carrierName?.name === 'SAIA' && CHKDGT) {
        cleanedProNumber = `${cleanedProNumber}${CHKDGT}`;
      }

      const hasValue = str => str && str.length > 0;

      const matchedProRow = hasValue(cleanedProNumber)
        ? cleanedApiData.find(apiRes => {
            const apiProNumber = normalize(apiRes?.proNumber);

            // Debug logging to see what's being compared
            console.log('Comparing:', {
              filePro: cleanedProNumber,
              apiPro: apiProNumber,
              match: apiProNumber === cleanedProNumber
            });

            return apiProNumber === cleanedProNumber;
          })
        : null;

      console.log('Match result:', {
        fileProNumber,
        cleanedProNumber,
        matched: !!matchedProRow,
        matchedRow: matchedProRow
      });

      tempArr.push({
        apiProNumber: matchedProRow?.proNumber || '',
        fileProNumber: fileProNumber || '',
        proNumberMatchedStatus: matchedProRow
          ? 'PRO# Matched'
          : 'PRO# Not Found'
      });
    });

    setComparisonData(tempArr);
    handleClickOpen();
  };

  const handleImportedData = newValue => {
    setShipmentsLoader(true);
    GetShipments(
      AgencyID,
      UserLoggedInEmail,
      1,
      10000,
      newValue === 1 ? 'DISPUTED' : 'RESOLVED',
      '',
      datesRange
    )
      .then(res => res.status === 200 && handleSuccessShipDetails(res))
      .catch(err => {
        console.log(err, 'Get Shipments Err---------->');
        setShipmentsLoader(false);
        ErrorToast('Get Shipments Invoices Failed!');
      });
  };

  const handleImportData = uploadedFile => {
    if (!uploadedFile) {
      ErrorToast('No file selected!');
      return;
    }

    if (!carrierName?.carrierId) {
      ErrorToast('Invalid carrier configuration!');
      return;
    }

    const formData = new FormData();
    formData.append('file', uploadedFile);

    ImportInvoiceAuditShipments(carrierName?.carrierId, formData)
      .then(res => {
        if (res?.status === 200 && res?.data) {
          handleMatchedNumbers(res.data);
        } else {
          ErrorToast('Unexpected API response!');
        }
      })
      .catch(err => {
        ErrorToast(err?.response?.data || 'API Error occurred!');
        setShipmentsLoader(false);
        console.log(err, 'API Error');
      });
  };

  const convertToCSV = data => {
    const headers = Object.keys(data[0]);
    const csvRows = data.map(row =>
      headers
        .map(field => `"${(row[field] ?? '').toString().replace(/"/g, '""')}"`)
        .join(',')
    );
    return [headers.join(','), ...csvRows].join('\r\n');
  };

  const handleImportValidRec = () => {
    setShipmentsLoader(true);
    setRowsData(validRowsFile);
    setViewInValidRecordsCopy(inValidRowsFile);

    const extension = fileName.split('.').pop().toLowerCase();
    let file;

    if (extension === 'csv') {
      const csvData = convertToCSV(validRowsFile);
      const csvBlob = new Blob([csvData], { type: 'text/csv' });
      file = new File([csvBlob], fileName, { type: 'text/csv' });
    } else if (extension === 'xls' || extension === 'xlsx') {
      const worksheet = XLSX.utils.json_to_sheet(validRowsFile);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      const wbout = XLSX.write(workbook, {
        bookType: extension,
        type: 'array'
      });

      const mimeType =
        extension === 'xls'
          ? 'application/vnd.ms-excel'
          : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      const excelBlob = new Blob([wbout], { type: mimeType });
      file = new File([excelBlob], fileName, { type: mimeType });
    } else {
      console.error('Unsupported file type');
      return;
    }

    handleImportData(file);
  };

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role='tabpanel'
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 1, height: '50vh' }}>{children}</Box>}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setFileName('');
    setFileNameErr(false);
    setUploadedFile(null);
    setCarrierName(null);
    if (newValue !== 2) {
      handleImportedData(newValue);
    }
    if (newValue === 2) {
      GetCarriers(AgencyID, 0).then(
        res => res.status === 200 && handleSuccesGetCarriers(res)
      );
    }
  };

  const handleTrackShipmentRequest = () => {};

  const handleViewShipments = (row, prop) => {
    return (
      <Box>
        <ViewInvoiceDetails rowData={row.original} />
      </Box>
    );
  };

  const handleCloseMarkAsReslv = rowData => {
    setMarkAsResolDialg(false);
  };

  const handleConfirmMarkAsResolv = () => {
    MarkAsResolvedDisputedShipment(currentRowData.id)
      .then(res => {
        res.status === 200 && successToast('Invoice Marked as Resolved!');
        handleCloseMarkAsReslv();
        handleImportedData();
        handleChange('event', 0);
      })
      .catch(err => {
        console.log(err, 'MarkAsResolvedDisputedShipmentErr--->>>.');
        ErrorToast(err?.message);
        handleCloseMarkAsReslv();
      });
  };

  const handleSendInvoiceReprts = table => {
    const invoiceReportKeys = [
      'shipmentId',
      'bolNumber',
      'proNumber',
      'shipmentCharges',
      'iaNetCharge',
      'surchargesList'
    ];
    const selectedRows = table
      .getSelectedRowModel()
      .rows.map(row => row.original);
    const invoiceReportArr = selectedRows.map(item =>
      Object.fromEntries(
        Object.entries(item).filter(([key]) => invoiceReportKeys.includes(key))
      )
    );
    const finalArray = invoiceReportArr.map(item => ({
      shipmentId: Number(item.shipmentId),
      bolNumber: item.bolNumber,
      proNumber: item.proNumber,
      tmsRate: Number(
        (
          item.shipmentCharges -
          (item.surchargesList.find(
            agencySurcharges => agencySurcharges.description === 'Surcharge'
          )?.amount?.amount || 0)
        ).toFixed(2)
      ),
      carrierRate: item.iaNetCharge
    }));

    SendDisputedInvoiceReport(finalArray)
      .then(res => {
        res.status === 200 && successToast('Invoice sent to AP successfully!');
      })
      .catch(err => {
        ErrorToast(err?.message);
        console.log(err, 'err report invoice');
      });
  };

  const columnsWithValidationHighlight = previewColumns.map(col => ({
    ...col,
    Cell: ({ cell, row }) => {
      const isInvalid = row.original[`${col.accessorKey}__invalid`] === true;
      return (
        <div
          style={{
            minHeight: '30px',
            width: 'auto',
            cursor: 'pointer',
            backgroundColor: isInvalid ? 'rgba(255, 0, 0, 0.2)' : 'transparent',
            color: isInvalid ? 'red' : 'inherit',
            fontWeight: isInvalid ? 'bold' : 'normal',
            padding: '4px',
            borderRadius: '2px',
            transition: 'background-color 0.3s ease'
          }}
          title={isInvalid ? 'Invalid value' : ''}
        >
          {cell.getValue()}
        </div>
      );
    }
  }));

  useEffect(() => {
    const validRows = rowsData.filter(
      row =>
        !Object.keys(row).some(
          key => key.endsWith('__invalid') && row[key] === true
        )
    );
    const inValidRows = rowsData.filter(row =>
      Object.keys(row).some(
        key => key.endsWith('__invalid') && row[key] === true
      )
    );
    setInValidRowsFile(inValidRows);
    setValidRowsFile(validRows);
  }, [rowsData]);

  const handleCloseMappingDialog = () => {
    setAllColumnsMatched(false);
    setApiCarrierCols([]);
    setValidRowsFile([]);
    setFileName('');
    setShowMappingDialog(false);
  };

  const checkNetChargeMapped = () => {
    if (!carrierName?.name || !apiCarrierColsDetails.length) return false;

    const netChargePatterns = [
      'netchg',
      'netcharge',
      'net charge',
      'totalcharge',
      'net revenue',
      'chgs'
    ];

    // Check if ANY field that looks like a net charge is mapped
    return columnMappings.some(m => {
      if (!m.isMapped || !m.carrierField) return false;
      const field = m.carrierField.toLowerCase();
      return netChargePatterns.some(pattern => field.includes(pattern));
    });
  };

  const getCarrierChargeLabel = carrierName => {
    if (!carrierName) return 'Net Charge';

    const chargeLabels = {
      SAIA: 'NETCHG',
      FedEx: 'Net Charge',
      'R and L Carriers': 'TotalCharge',
      SEFL: 'NET CHARGES',
      ESTES: 'NET CHARGES',
      XPO: 'Net Revenue',
      'AAA Cooper': 'CHGS'
    };

    return chargeLabels[carrierName] || 'Net Charge';
  };

  const isMandatoryField = (fieldKey, carrierName) => {
    if (!fieldKey) return false;

    const proNumberVariants = [
      'pro#',
      'pro number',
      'pronumber',
      'pro',
      'tracking number'
    ];

    const netChargeVariants = [
      'netchg',
      'net charge',
      'net charges',
      'totalcharge',
      'net revenue',
      'chgs'
    ];

    const lowerField = fieldKey.toLowerCase();

    if (proNumberVariants.some(variant => lowerField.includes(variant))) {
      return true;
    }

    if (netChargeVariants.some(variant => lowerField.includes(variant))) {
      return true;
    }

    return false;
  };

  const checkProNumberMapped = () => {
    if (!carrierName?.name || !apiCarrierColsDetails.length) return false;

    // Check if ANY field that looks like a PRO number is mapped
    return columnMappings.some(m => {
      if (!m.isMapped || !m.carrierField) return false;
      const field = m.carrierField.toLowerCase();
      return (
        field.includes('pro') ||
        field.includes('tracking') ||
        field.includes('pronumber') ||
        field.includes('pro#')
      );
    });
  };

  // UPDATED RENDER MAPPING DIALOG - Auto-mapped columns are locked and disabled
  const renderMappingDialog = () => (
    <Dialog
      open={showMappingDialog}
      onClose={() => handleCloseMappingDialog()}
      maxWidth='md'
      fullWidth
      PaperProps={{
        sx: {
          maxWidth: '80vw',
          maxHeight: '90vh',
          m: 1
        }
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
          pt: 2
        }}
      >
        <Typography variant='h6' fontSize='1.1rem' fontWeight='600'>
          Map Uploaded Columns to Carrier Fields
        </Typography>
        <IconButton
          onClick={() => setShowMappingDialog(false)}
          size='small'
          sx={{ p: 0.5 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          {/* Status Bar - Enhanced with mandatory fields validation */}
          <Box
            sx={{
              mb: 2,
              p: 1.5,
              borderRadius: 1,
              border: '1px solid',
              borderColor: isMappingComplete ? 'success.main' : 'warning.main',
              bgcolor: 'transparent'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 1
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  flexWrap: 'wrap'
                }}
              >
                <Chip
                  label={`${mappedCount}/${apiCarrierColsDetails.length} fields mapped`}
                  size='small'
                  variant='outlined'
                  color={isMappingComplete ? 'success' : 'warning'}
                />

                {/* PRO Number validation status - Now shows carrier-specific label */}
                <Chip
                  label={`${proNumberKey}: ${checkProNumberMapped() ? '✓' : 'Required'}`}
                  size='small'
                  color={checkProNumberMapped() ? 'success' : 'error'}
                  variant={checkProNumberMapped() ? 'filled' : 'outlined'}
                  icon={
                    checkProNumberMapped() ? (
                      <CheckCircleIcon />
                    ) : (
                      <WarningIcon />
                    )
                  }
                  sx={{
                    '& .MuiChip-icon': {
                      fontSize: '1rem',
                      color: checkProNumberMapped() ? 'white' : '#d32f2f'
                    }
                  }}
                />

                {/* Net Charge validation status - Now shows the actual key name */}
                <Chip
                  label={`${netChargeKey}: ${checkNetChargeMapped() ? '✓' : 'Required'}`}
                  size='small'
                  color={checkNetChargeMapped() ? 'success' : 'error'}
                  variant={checkNetChargeMapped() ? 'filled' : 'outlined'}
                  icon={
                    checkNetChargeMapped() ? (
                      <CheckCircleIcon />
                    ) : (
                      <WarningIcon />
                    )
                  }
                  sx={{
                    '& .MuiChip-icon': {
                      fontSize: '1rem',
                      color: checkNetChargeMapped() ? 'white' : '#d32f2f'
                    }
                  }}
                />
              </Box>

              <Typography variant='caption' color='text.secondary'>
                <span style={{ color: '#ff9800' }}>🔒 Locked fields</span> are
                auto-mapped by system
              </Typography>
            </Box>
          </Box>

          {/* MAPPING TABLE - Single scrollable container */}
          <Box
            sx={{
              height: '55vh',
              overflow: 'auto',
              border: '1px solid #e0e0e0',
              borderRadius: 1,
              mb: 2
            }}
          >
            {/* Table Header */}
            <Box
              sx={{
                p: 1,
                bgcolor: 'grey.50',
                borderBottom: '1px solid #e0e0e0',
                position: 'sticky',
                top: 0,
                zIndex: 1
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={5}>
                  <Typography variant='subtitle2' fontSize='0.85rem'>
                    Uploaded Column
                  </Typography>
                </Grid>
                <Grid item xs={2} sx={{ textAlign: 'center' }}>
                  <Typography variant='subtitle2' fontSize='0.85rem'>
                    →
                  </Typography>
                </Grid>
              </Grid>
            </Box>

            {/* Table Body */}
            <Box sx={{ p: 1 }}>
              {/* Group mapped fields first */}
              {columnMappings
                .sort((a, b) => {
                  // Show mapped fields first, then unmapped
                  if (a.isMapped && !b.isMapped) return -1;
                  if (!a.isMapped && b.isMapped) return 1;
                  return 0;
                })
                .map(
                  (mapping, index) =>
                    mapping.uploadedField && (
                      <Grid
                        container
                        spacing={1}
                        key={index}
                        sx={{
                          mb: 1.5,
                          alignItems: 'center',
                          opacity: mapping.isMapped ? 1 : 0.8,
                          ...(isMandatoryField(mapping.carrierField) &&
                            mapping.isMapped && {
                              borderLeft: '4px solid #4caf50',
                              pl: 1
                            }),
                          ...(isMandatoryField(mapping.carrierField) &&
                            !mapping.isMapped && {
                              borderLeft: '4px solid #f44336',
                              pl: 1,
                              bgcolor: '#ffebee'
                            })
                        }}
                      >
                        {/* Left: Uploaded Column */}
                        <Grid item xs={5}>
                          <Box
                            sx={{
                              p: 1,
                              borderRadius: 0.5,
                              border: '1px solid #e0e0e0',
                              bgcolor: mapping.isMapped ? 'grey.50' : 'white',
                              minHeight: '40px',
                              display: 'flex',
                              alignItems: 'center',
                              flexWrap: 'wrap',
                              gap: 0.5
                            }}
                          >
                            <Typography variant='body2' fontSize='0.9rem'>
                              {mapping.uploadedField}
                            </Typography>

                            {mapping.isExactMatch && mapping.isMapped && (
                              <Chip
                                label='Auto'
                                size='small'
                                color='success'
                                variant='outlined'
                                sx={{ ml: 1, height: 20, fontSize: '0.7rem' }}
                              />
                            )}
                          </Box>
                        </Grid>

                        {/* Middle: Arrow */}
                        <Grid item xs={2} sx={{ textAlign: 'center' }}>
                          <ArrowForwardIcon
                            fontSize='small'
                            sx={{
                              color: mapping.isMapped
                                ? 'primary.main'
                                : 'grey.400'
                            }}
                          />
                        </Grid>

                        {/* Right: Carrier Field - DISABLED for auto-mapped columns */}
                        <Grid item xs={5}>
                          <Box sx={{ position: 'relative' }}>
                            <Select
                              fullWidth
                              size='small'
                              value={mapping.carrierField || ''}
                              // Disable if it's a saved mapping (auto-mapped by system)
                              disabled={mapping.isSavedMapping}
                              onChange={e => {
                                const newValue = e.target.value;
                                const newMappings = [...columnMappings];

                                // Find current mapping index
                                const currentIndex = newMappings.findIndex(
                                  m => m.uploadedField === mapping.uploadedField
                                );

                                if (currentIndex !== -1) {
                                  // Store the old carrier field (if any)
                                  const oldCarrierField =
                                    newMappings[currentIndex].carrierField;

                                  // Update current mapping
                                  newMappings[currentIndex].carrierField =
                                    newValue;
                                  newMappings[currentIndex].isMapped =
                                    !!newValue;
                                  newMappings[currentIndex].isExactMatch =
                                    false;
                                  // Preserve saved mapping flag and value if it was a saved mapping
                                  if (mapping.isSavedMapping) {
                                    newMappings[currentIndex].isSavedMapping =
                                      true;
                                    newMappings[currentIndex].savedValue =
                                      mapping.savedValue;
                                  }

                                  // If there was an old carrier field, clear it from any other mapping
                                  if (
                                    oldCarrierField &&
                                    oldCarrierField !== newValue
                                  ) {
                                    newMappings.forEach((m, idx) => {
                                      if (
                                        idx !== currentIndex &&
                                        m.carrierField === oldCarrierField
                                      ) {
                                        m.carrierField = '';
                                        m.isMapped = false;
                                        m.isExactMatch = false;
                                      }
                                    });
                                  }

                                  // If selecting a new carrier field, clear it from any other mapping
                                  if (newValue) {
                                    newMappings.forEach((m, idx) => {
                                      if (
                                        idx !== currentIndex &&
                                        m.carrierField === newValue
                                      ) {
                                        m.carrierField = '';
                                        m.isMapped = false;
                                        m.isExactMatch = false;
                                      }
                                    });
                                  }
                                }

                                setColumnMappings(newMappings);
                                const newMappedCount = newMappings.filter(
                                  m =>
                                    m.isMapped &&
                                    apiCarrierColsDetails.some(
                                      c => c.key === m.carrierField
                                    )
                                ).length;
                                setMappedCount(newMappedCount);
                                setIsMappingComplete(
                                  newMappedCount ===
                                    apiCarrierColsDetails.length
                                );
                              }}
                              displayEmpty
                              renderValue={selected => {
                                if (!selected) {
                                  return (
                                    <Typography
                                      variant='body2'
                                      color='text.secondary'
                                    >
                                      {mapping.isCarrierOnly
                                        ? 'Select uploaded column'
                                        : 'Select carrier field'}
                                    </Typography>
                                  );
                                }
                                return selected;
                              }}
                              sx={{
                                '& .MuiSelect-select': {
                                  fontSize: '0.9rem',
                                  py: 0.8,
                                  bgcolor: mapping.isSavedMapping
                                    ? '#fff3e0' // Light orange background for locked fields
                                    : mapping.isMapped
                                      ? 'grey.50'
                                      : 'white',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  ...(isMandatoryField(selected) && {
                                    fontWeight: 600,
                                    color: '#2e7d32'
                                  })
                                },
                                '&.Mui-disabled': {
                                  '& .MuiSelect-select': {
                                    backgroundColor: '#fff3e0',
                                    color: '#666',
                                    cursor: 'not-allowed'
                                  }
                                }
                              }}
                              MenuProps={{
                                PaperProps: {
                                  sx: {
                                    maxHeight: 250
                                  }
                                }
                              }}
                            >
                              <MenuItem value=''>
                                <Typography
                                  variant='body2'
                                  color='text.secondary'
                                >
                                  {mapping.isCarrierOnly
                                    ? 'Select uploaded column'
                                    : 'Select carrier field'}
                                </Typography>
                              </MenuItem>
                              {mapping.isCarrierOnly
                                ? // For carrier-only rows, show uploaded columns to map to
                                  columnMappings
                                    .filter(
                                      m =>
                                        !m.isCarrierOnly &&
                                        m.uploadedField &&
                                        !m.isMapped
                                    )
                                    .map((uploadedCol, colIndex) => (
                                      <MenuItem
                                        key={`uploaded-${colIndex}`}
                                        value={uploadedCol.uploadedField}
                                        sx={{
                                          fontSize: '0.9rem',
                                          display: 'flex',
                                          justifyContent: 'space-between'
                                        }}
                                      >
                                        <span>{uploadedCol.uploadedField}</span>
                                      </MenuItem>
                                    ))
                                : // For regular rows, show carrier fields to map to
                                  apiCarrierColsDetails.map(
                                    (carrierCol, colIndex) => {
                                      const isMappedElsewhere =
                                        columnMappings.some(
                                          m =>
                                            m.carrierField ===
                                              carrierCol.caption &&
                                            m.uploadedField !==
                                              mapping.uploadedField
                                        );

                                      // Check if this carrier field is already auto-mapped (saved mapping)
                                      const isAutoMapped = columnMappings.some(
                                        m =>
                                          m.carrierField ===
                                            carrierCol.caption &&
                                          m.isSavedMapping
                                      );

                                      // Check if this is a mandatory field
                                      const isMandatory = isMandatoryField(
                                        carrierCol.caption,
                                        carrierName?.name
                                      );

                                      return (
                                        <MenuItem
                                          key={colIndex}
                                          value={carrierCol.caption}
                                          disabled={isAutoMapped} // Disable if this field is already auto-mapped
                                          sx={{
                                            fontSize: '0.9rem',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            bgcolor: isMappedElsewhere
                                              ? 'inherit'
                                              : 'inherit',
                                            '&:hover': {
                                              bgcolor: 'action.hover'
                                            },
                                            '&.Mui-disabled': {
                                              opacity: 0.5,
                                              backgroundColor: '#f5f5f5'
                                            },
                                            ...(isMandatory && {
                                              fontWeight: 600,
                                              borderLeft: '3px solid #d32f2f'
                                            })
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              gap: 1
                                            }}
                                          >
                                            <span>
                                              {carrierCol.caption}
                                              {isMandatory && (
                                                <span
                                                  style={{
                                                    marginLeft: '4px',
                                                    color: '#d32f2f',
                                                    fontSize: '0.75rem',
                                                    fontWeight: 'bold'
                                                  }}
                                                >
                                                  *
                                                </span>
                                              )}
                                            </span>
                                            {isAutoMapped && (
                                              <span
                                                style={{
                                                  marginLeft: '8px',
                                                  color: '#ff9800',
                                                  fontSize: '0.75rem'
                                                }}
                                              >
                                                (auto-mapped)
                                              </span>
                                            )}
                                          </Box>
                                          {mapping.carrierField ===
                                          carrierCol.caption ? (
                                            <Box
                                              sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 0.5
                                              }}
                                            >
                                              <CheckCircleIcon
                                                fontSize='small'
                                                sx={{ color: 'success.main' }}
                                              />
                                              <Chip
                                                label='Mapped'
                                                size='small'
                                                color='warning'
                                                variant='outlined'
                                                sx={{
                                                  height: 20,
                                                  fontSize: '0.7rem'
                                                }}
                                              />
                                            </Box>
                                          ) : null}
                                        </MenuItem>
                                      );
                                    }
                                  )}
                            </Select>

                            {/* Lock icon for disabled fields */}
                            {mapping.isSavedMapping && (
                              <Tooltip title='This field is auto-mapped by the system and cannot be changed'>
                                <Box
                                  sx={{
                                    position: 'absolute',
                                    right: 30,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    color: '#ff9800',
                                    zIndex: 1,
                                    pointerEvents: 'none'
                                  }}
                                >
                                  🔒
                                </Box>
                              </Tooltip>
                            )}
                          </Box>

                          {/* Status indicators below select */}
                          {mapping.isMapped && (
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                mt: 0.5,
                                p: 0.5,
                                bgcolor: '#f5f5f5',
                                borderRadius: 1,
                                flexWrap: 'wrap'
                              }}
                            >
                              <CheckCircleIcon
                                fontSize='small'
                                sx={{
                                  color: 'success.main',
                                  fontSize: '0.8rem'
                                }}
                              />
                              <Typography
                                variant='caption'
                                color='success.main'
                                fontWeight={500}
                              >
                                Mapped to: {mapping.carrierField}
                                {isMandatoryField(mapping.carrierField) &&
                                  ' (Required ✓)'}
                              </Typography>

                              {mapping.isExactMatch && (
                                <Chip
                                  label='Auto-match'
                                  size='small'
                                  color='success'
                                  variant='outlined'
                                  sx={{ height: 20, fontSize: '0.65rem' }}
                                />
                              )}

                              {/* Show lock indicator for auto-mapped fields */}
                              {mapping.isSavedMapping && (
                                <Chip
                                  label='System locked'
                                  size='small'
                                  icon={<span>🔒</span>}
                                  sx={{
                                    height: 20,
                                    fontSize: '0.65rem',
                                    bgcolor: '#fff3e0',
                                    color: '#e65100',
                                    '& .MuiChip-icon': {
                                      fontSize: '0.7rem',
                                      marginLeft: '4px'
                                    }
                                  }}
                                />
                              )}
                            </Box>
                          )}
                        </Grid>
                      </Grid>
                    )
                )}
            </Box>
          </Box>
        </DialogContentText>

        {/* Action Buttons */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 2,
            pt: 2,
            borderTop: '1px solid #e0e0e0'
          }}
        >
          {/* Quick Stats - Left */}
          <Box
            sx={{
              display: 'flex',
              gap: 3,
              alignItems: 'center',
              flexWrap: 'wrap'
            }}
          >
            <Box>
              <Typography variant='caption' color='text.secondary'>
                Uploaded
              </Typography>
              <Typography variant='body2' fontWeight='500'>
                {columns.length} columns
              </Typography>
            </Box>
            <Box>
              <Typography variant='caption' color='text.secondary'>
                Mapped
              </Typography>
              <Typography
                variant='body2'
                fontWeight='500'
                color={isMappingComplete ? 'success.main' : 'inherit'}
              >
                {mappedCount} of {apiCarrierColsDetails.length}
              </Typography>
            </Box>
            <Box>
              <Typography variant='caption' color='text.secondary'>
                Saved Mappings
              </Typography>
              <Typography variant='body2' fontWeight='500' color='info.main'>
                {
                  columnMappings.filter(m => m.isSavedMapping && m.isMapped)
                    .length
                }
              </Typography>
            </Box>
            <Box>
              <Typography variant='caption' color='text.secondary'>
                Auto-matched
              </Typography>
              <Typography variant='body2' fontWeight='500' color='success.main'>
                {
                  columnMappings.filter(m => m.isExactMatch && m.isMapped)
                    .length
                }
              </Typography>
            </Box>
            <Box>
              <Typography variant='caption' color='text.secondary'>
                🔒 Locked
              </Typography>
              <Typography variant='body2' fontWeight='500' color='warning.main'>
                {columnMappings.filter(m => m.isSavedMapping).length}
              </Typography>
            </Box>
          </Box>

          {/* Center - Auto-match and Clear buttons */}
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Button
              variant='outlined'
              onClick={() => {
                // Auto-match logic - but preserve saved mappings
                const newMappings = [...columnMappings];
                const unmappedUploaded = newMappings.filter(
                  m => !m.isMapped && !m.isCarrierOnly
                );

                // Get unmapped carrier fields (excluding saved mappings)
                const unmappedCarrier = apiCarrierColsDetails.filter(
                  carrierCol =>
                    !newMappings.some(
                      m => m.carrierField === carrierCol.key && m.isMapped
                    ) &&
                    !newMappings.some(
                      m => m.carrierField === carrierCol.key && m.isSavedMapping
                    )
                );

                unmappedUploaded.forEach(mapping => {
                  const exactMatch = unmappedCarrier.find(
                    carrierCol =>
                      carrierCol.key.toLowerCase() ===
                      mapping.uploadedField.toLowerCase()
                  );
                  if (exactMatch) {
                    mapping.carrierField = exactMatch.key;
                    mapping.isMapped = true;
                    mapping.isExactMatch = true;

                    const index = unmappedCarrier.findIndex(
                      c => c.key === exactMatch.key
                    );
                    if (index > -1) unmappedCarrier.splice(index, 1);
                  }
                });

                setColumnMappings(newMappings);
                const newMappedCount = newMappings.filter(
                  m =>
                    m.isMapped &&
                    apiCarrierColsDetails.some(c => c.key === m.carrierField)
                ).length;
                setMappedCount(newMappedCount);
                setIsMappingComplete(
                  newMappedCount === apiCarrierColsDetails.length
                );
              }}
              startIcon={<AutoAwesomeIcon />}
              size='small'
            >
              Auto-match
            </Button>
            <Button
              variant='outlined'
              onClick={() => {
                // Clear all mappings except saved ones
                setColumnMappings(
                  columnMappings.map(m => ({
                    ...m,
                    // Only clear if it's not a saved mapping
                    carrierField: m.isSavedMapping ? m.carrierField : '',
                    isMapped: m.isSavedMapping ? true : false,
                    isExactMatch: m.isSavedMapping ? m.isExactMatch : false
                  }))
                );
                // Recalculate mapped count (excluding saved mappings from being counted as unmapped)
                const savedMappingsCount = columnMappings.filter(
                  m => m.isSavedMapping && m.isMapped
                ).length;
                setMappedCount(savedMappingsCount);
                setIsMappingComplete(
                  savedMappingsCount === apiCarrierColsDetails.length
                );
              }}
              startIcon={<ClearAllIcon />}
              color='error'
              size='small'
            >
              Clear All (except locked)
            </Button>
          </Box>

          {/* Right - Cancel and Preview buttons */}
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Button
              onClick={() => handleCloseMappingDialog()}
              variant='outlined'
              size='small'
            >
              Cancel
            </Button>
            <Button
              variant='contained'
              onClick={() => {
                // Check if mandatory fields are mapped before proceeding
                if (!checkProNumberMapped() || !checkNetChargeMapped()) {
                  const chargeLabel = getCarrierChargeLabel(carrierName?.name);
                  ErrorToast(
                    `Please map both ${getCarrierProLabel(carrierName?.name)} and ${chargeLabel} fields before previewing data!`
                  );
                  return;
                }

                preparePreviewTableData();
                setShowMappingDialog(false);
              }}
              size='small'
              sx={{ minWidth: 140 }}
              disabled={!checkProNumberMapped() || !checkNetChargeMapped()}
            >
              Preview Data
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );

  return (
    <Grid
      container
      sx={{
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <ToastContainer
        style={{ width: 'auto', maxWidth: '90vw' }}
        position='top-center'
        autoClose={6800}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <PreviewDataTable />
      {renderMappingDialog()}

      <Dialog
        maxWidth='md'
        minWidth='xs'
        sx={{ '& .MuiDialog-paper': { minWidth: '550px', minHeight: '300px' } }}
        open={markAsResolDialg}
        onClose={handleCloseMarkAsReslv}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          {'Mark Invoice As Resolved Confirmation Dialog'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            <TextField
              sx={{ mt: 2 }}
              multiline
              fullWidth
              label='Enter Commnents'
            />
            <div style={{ marginTop: 20 }}>
              <span>Select file as proof for this invoice (optional)</span>
              <br />
              <input title='choose file' type='file' accept='*' />
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            size='small'
            variant='outlined'
            color='warning'
            onClick={handleCloseMarkAsReslv}
          >
            Cancel
          </Button>
          <Button
            size='small'
            variant='contained'
            color='success'
            onClick={() => handleConfirmMarkAsResolv()}
            autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Box sx={{ width: '100%' }}>
        <Box
          sx={{ borderBottom: 1, borderColor: 'divider', width: '97%', m: 1 }}
          className='bg-white mb-2 d-flex align-items-center justify-content-between px-0 pe-3'
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label='scrollable tabs example'
            allowScrollButtonsMobile
            sx={{
              ml: 2,
              '& .MuiTabs-scrollButtons': {
                '&.Mui-disabled': { opacity: 0.3 }
              }
            }}
          >
            <Tab label='Resolved Invoices' {...a11yProps(0)} />
            <Tab label='Disputed Invoices' {...a11yProps(1)} />
            <Tab label='Import New invoice' {...a11yProps(2)} />
          </Tabs>
        </Box>

        <CustomTabPanel value={value} index={0}>
          <Grid sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <MaterialReactTable
              data={disputedShipments}
              columns={invoiceAuditColumns}
              enableStickyHeader
              initialState={{
                rowSelection,
                density: 'compact',
                isLoading: shipmentsLoader,
                showSkeletons: shipmentsLoader
              }}
              renderTopToolbarCustomActions={({ table }) => {
                const selectedCount = Object.keys(rowSelection).length;
                return selectedCount > 0 ? (
                  <Box display='flex' alignItems='center' gap={2}>
                    <Button
                      size='small'
                      variant='contained'
                      color='primary'
                      onClick={() => {
                        handleSendInvoiceReprts(table);
                      }}
                    >
                      Mail Invoice <ForwardToInboxIcon sx={{ ml: 1 }} />
                    </Button>
                  </Box>
                ) : null;
              }}
              muiTableContainerProps={{
                sx: {
                  mr: 3,
                  minWidth: '90vw',
                  maxWidth: '90vw',
                  maxHeight: '70vh',
                  minHeight: '64vh'
                }
              }}
              muiBottomToolbarProps={{
                style: {
                  padding: '0.5rem'
                }
              }}
              enableRowSelection
              onRowSelectionChange={setRowSelection}
            />
          </Grid>
        </CustomTabPanel>

        <CustomTabPanel value={value} index={1}>
          <Grid sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <MaterialReactTable
              data={disputedShipments}
              columns={invoiceAuditColumns}
              enableStickyHeader
              enableGrouping
              initialState={{
                rowSelection,
                density: 'compact',
                isLoading: shipmentsLoader,
                showSkeletons: shipmentsLoader
              }}
              renderTopToolbarCustomActions={({ table }) => {
                const selectedCount = Object.keys(rowSelection).length;
                return selectedCount > 0 ? (
                  <Box display='flex' alignItems='center' gap={2}>
                    <Button
                      size='small'
                      variant='contained'
                      color='primary'
                      onClick={() => {
                        handleSendInvoiceReprts(table);
                      }}
                    >
                      Mail Invoice <ForwardToInboxIcon sx={{ ml: 1 }} />
                    </Button>
                  </Box>
                ) : null;
              }}
              muiTableContainerProps={{
                sx: {
                  mr: 3,
                  minWidth: '90vw',
                  maxWidth: '90vw',
                  maxHeight: '64vh',
                  minHeight: '64vh'
                }
              }}
              enableRowActions
              renderRowActions={({ row }) => (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Tooltip
                    sx={{ cursor: 'pointer' }}
                    arrow
                    title='Mark as resolved'
                    onClick={() => {
                      setCurrentRowData(row.original);
                      setMarkAsResolDialg(true);
                    }}
                  >
                    <LibraryAddCheckIcon color='success' />
                  </Tooltip>
                </Box>
              )}
              renderDetailPanel={({ row }) => handleViewShipments(row)}
              muiBottomToolbarProps={{
                style: {
                  padding: '0.5rem'
                }
              }}
              enableRowSelection
              onRowSelectionChange={setRowSelection}
            />
          </Grid>
        </CustomTabPanel>

        <CustomTabPanel value={value} index={2}>
          <Grid
            sx={{ mb: 1, ml: 0, display: 'flex', alignItems: 'center' }}
            container
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
          >
            <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
              <Autocomplete
                fullWidth
                size='small'
                renderOption={(PreviousProps, option) => (
                  <Box style={{ fontSize: 13 }} {...PreviousProps}>
                    <li {...PreviousProps}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          paddingLeft: '5px'
                        }}
                      >
                        <AvatarGroup spacing='small'>
                          <Avatar
                            sx={{
                              bgcolor: 'ButtonFace',
                              objectFit: 'contain'
                            }}
                            imgProps={{
                              style: {
                                height: 45
                              }
                            }}
                            src={base_logo_url + option.logo}
                          />
                        </AvatarGroup>
                      </Box>
                      <span style={{ marginLeft: 5 }}>{option.name}</span>
                    </li>
                  </Box>
                )}
                value={carrierName || null}
                onChange={(event, newValue) =>
                  handleCarrierChange(event, newValue)
                }
                options={carrierApiNames}
                getOptionLabel={option => option.name || ''}
                renderInput={params => (
                  <TextField
                    fullWidth
                    {...params}
                    sx={{
                      '& .MuiInputBase-input': {
                        fontSize: '14px'
                      },
                      '& .MuiInputLabel-root': {
                        fontSize: '14px'
                      }
                    }}
                    FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                    label='Select carrier'
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: carrierName && (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            paddingLeft: '5px'
                          }}
                        >
                          <Avatar
                            sx={{
                              bgcolor: 'ButtonFace',
                              objectFit: 'contain',
                              height: 20
                            }}
                            imgProps={{
                              style: {
                                height: 20
                              }
                            }}
                            src={base_logo_url + carrierName.logo}
                          />
                        </Box>
                      )
                    }}
                  />
                )}
              />
            </Grid>

            <Grid sx={{ ml: 1 }} item xs={12} sm={2} md={2} lg={2} xl={2}>
              <input
                type='file'
                accept='.csv, .xls, .xlsx'
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileImport}
              />
              <Button
                disabled={
                  carrierName?.name && apiCarrierCols.length !== 1
                    ? false
                    : true
                }
                fullWidth
                sx={{ minWidth: '8vw', width: 'auto', height: 37 }}
                variant='contained'
                onClick={() => handleImportClick()}
              >
                {selectCarrierLoading ? (
                  <CircularProgress
                    sx={{
                      color:
                        carrierName?.name && apiCarrierCols.length !== 1
                          ? 'white'
                          : '#495057'
                    }}
                    size={20}
                  />
                ) : fileName &&
                  allColumnsMatched &&
                  apiCarrierCols &&
                  inValidRowsFile.length !== 0 ? (
                  'Update and Import'
                ) : (
                  'Upload File'
                )}
              </Button>
            </Grid>

            {rowsData.length > 0 && comparisonData.length > 0 && fileName && (
              <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                scroll='body'
                maxWidth='lg'
                fullWidth
                PaperProps={{
                  sx: {
                    width: 'auto',
                    maxWidth: '90vw',
                    height: 'auto',
                    maxHeight: '90vh',
                    m: 2
                  }
                }}
              >
                <DialogTitle
                  sx={{ display: 'flex', justifyContent: 'space-between' }}
                  id='alert-dialog-title'
                >
                  <Alert severity='info'>
                    {importedOriginalApiRes.length === 0
                      ? 'No Records'
                      : `${importedOriginalApiRes.length} Records successfully`}{' '}
                    imported out of{' '}
                    {getUniqueByProNumber(comparisonData).length} records.
                    {/* {importedOriginalApiRes.length !== 0 &&
                      importedOriginalApiRes.length !== rowsData.length &&
                      `${
                        rowsData.length - importedOriginalApiRes.length
                      } records not found!`} */}
                    {viewInValidRecordsCopy.length !== 0 && (
                      <Button
                        variant='outlined'
                        size='small'
                        sx={{ textTransform: 'lowercase', ml: 2 }}
                        onClick={() => setViewInValidRecords(state => !state)}
                      >
                        {viewInValidRecords
                          ? 'Hide invalid records'
                          : 'View invalid records'}
                      </Button>
                    )}
                  </Alert>

                  <ClearIcon onClick={handleClose} sx={{ cursor: 'pointer' }} />
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id='alert-dialog-description'>
                    {viewInValidRecords ? (
                      <Grid>
                        <MaterialReactTable
                          enableRowNumbers
                          data={viewInValidRecordsCopy}
                          columns={columnsWithValidationHighlight}
                          enableStickyHeader
                          initialState={{
                            showColumnFilters: true,
                            density: 'compact'
                          }}
                          muiBottomToolbarProps={{
                            style: {
                              padding: 10
                            }
                          }}
                        />
                      </Grid>
                    ) : (
                      <Grid>
                        <MaterialReactTable
                          enableRowNumbers
                          data={getUniqueByProNumber(comparisonData)}
                          columns={importedFileCoulmns}
                          enableStickyHeader
                          initialState={{
                            showColumnFilters: true,
                            density: 'compact'
                          }}
                          muiBottomToolbarProps={{
                            style: {
                              padding: 10
                            }
                          }}
                        />
                      </Grid>
                    )}
                  </DialogContentText>
                </DialogContent>
              </Dialog>
            )}
          </Grid>

          {fileName && apiCarrierCols && inValidRowsFile.length !== 0 && (
            <Grid>
              <MaterialReactTable
                enableRowNumbers
                renderTopToolbarCustomActions={({ table }) => {
                  return (
                    <Box display='flex' alignItems='center' gap={2}>
                      <Alert severity='error'>
                        <b>Data Validation Alert!</b>
                        <br />
                        We found <b>{inValidRowsFile.length}</b> invalid records
                        out of <b>{rowsData.length}</b> total. Would you like to
                        Update and re-upload the file after correcting the
                        invalid records, OR Proceed by importing only the{' '}
                        <b>{validRowsFile.length}</b> valid records?
                      </Alert>
                    </Box>
                  );
                }}
                data={inValidRowsFile}
                columns={columnsWithValidationHighlight}
                enableStickyHeader
                initialState={{
                  showColumnFilters: true,
                  density: 'compact'
                }}
                muiTableContainerProps={{
                  sx: {
                    maxHeight: '55vh',
                    minHeight: '55vh'
                  }
                }}
                muiBottomToolbarProps={{
                  style: {
                    padding: 10
                  }
                }}
              />
            </Grid>
          )}

          {/* {fileName && !allColumnsMatched && (
            <Card sx={{ mt: 2 }}>
              <CardContent>
                <Typography variant='h6' gutterBottom>
                  Column Mapping Required
                </Typography>
                <Typography
                  variant='body2'
                  color='text.secondary'
                  sx={{ mb: 2 }}
                >
                  {matchedCount} out of {apiCarrierCols.length} columns
                  automatically matched.
                  {columnMappings.length > 0 && (
                    <Button
                      variant='outlined'
                      size='small'
                      sx={{ ml: 2 }}
                      onClick={() => setShowMappingDialog(true)}
                    >
                      {isMappingComplete
                        ? 'View/Edit Mappings'
                        : 'Complete Mapping'}
                    </Button>
                  )}
                </Typography>

                {columnMappings.length > 0 && (
                  <Box
                    sx={{ mt: 2, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}
                  >
                    <Typography variant='subtitle2' sx={{ mb: 1 }}>
                      Current Mappings:
                    </Typography>
                    {columnMappings
                      .filter(m => m.isMapped)
                      .map((mapping, index) => (
                        <Chip
                          key={index}
                          label={`${mapping.uploadedField} → ${mapping.carrierField}${mapping.isSavedMapping && mapping.savedValue ? ` (from ${mapping.savedValue})` : ''}`}
                          size='small'
                          color={mapping.isSavedMapping ? 'info' : 'primary'}
                          sx={{ mr: 1, mb: 1 }}
                        />
                      ))}
                  </Box>
                )}
              </CardContent>
            </Card>
          )} */}
        </CustomTabPanel>
      </Box>
    </Grid>
  );
}
